jQuery(function ($) {
    const CATALOG_SESSION_SCHEMA = '2026-10-07-inline-ad-window-v1';

    function clearCatalogSessionData() {
        if (typeof window.carbuyClearCatalogSessionStorage === 'function') {
            window.carbuyClearCatalogSessionStorage();
            try { sessionStorage.removeItem('catalogContentSchema'); } catch (e0) {}
            return;
        }
        try {
            [
                'catalogCarsHtml',
                'catalogFilters',
                'catalogPage',
                'catalogHasMore',
                'catalogScroll',
                'catalogContentLang',
                'catalogContentSchema',
            ].forEach(function (k) {
                sessionStorage.removeItem(k);
            });
        } catch (e1) {}
    }

    function ensureCatalogSessionSchema() {
        let storedSchema = '';
        try {
            storedSchema = String(sessionStorage.getItem('catalogContentSchema') || '');
        } catch (e) {}
        if (storedSchema !== CATALOG_SESSION_SCHEMA) {
            clearCatalogSessionData();
            try { sessionStorage.setItem('catalogContentSchema', CATALOG_SESSION_SCHEMA); } catch (e2) {}
        }
    }

    function catalogSessionLangKey() {
        return String(document.documentElement.lang || 'lv').toLowerCase().split('-')[0];
    }

    /** Drop stale catalog restore data if UI locale no longer matches (e.g. language switched in another tab). */
    function clearCatalogSessionIfLanguageChanged() {
        let stored = null;
        try {
            stored = sessionStorage.getItem('catalogContentLang');
        } catch (e) {}
        const now = catalogSessionLangKey();
        let hasHtml = false;
        try {
            hasHtml = !!(sessionStorage.getItem('catalogCarsHtml'));
        } catch (e0) {}
        // Legacy sessions: cached HTML without locale tag — cannot trust language
        if (hasHtml && !stored) {
            clearCatalogSessionData();
            return;
        }
        if (stored && stored !== now) {
            clearCatalogSessionData();
        }
    }

    function touchCatalogSessionLang() {
        try {
            sessionStorage.setItem('catalogContentLang', catalogSessionLangKey());
            sessionStorage.setItem('catalogContentSchema', CATALOG_SESSION_SCHEMA);
        } catch (e) {}
    }

    ensureCatalogSessionSchema();
    clearCatalogSessionIfLanguageChanged();

    // Check if required elements exist before proceeding
    const catalogParent = $(".catalog-form");
    const carsContainer = $("#cars-wrapper");
    const loadingIndicator = $(".loading-indicator");
    const noResultsMessage = $(".catalog-no-results");
    const paginationContainer = $(".catalog-pagination");

    // -----------------------------
    // Inline ad card (catalog grid) — the server sends one car less on pages flagged
    // `inlineAd`, so the card fills that cell and rows stay full (no listing is skipped)
    // -----------------------------
    function buildInlineAdPlaceholderElement() {
        // Prefer server-rendered template (keeps markup consistent with PHP placeholders)
        // If template is missing or empty, it means ads/placeholders are disabled -> do NOT inject anything.
        const tpl = document.getElementById('carbuy-ad-inline-template');
        if (!tpl) return null;

        const html = String(tpl.innerHTML || '').trim();
        if (!html) return null;

        const $el = $(html);
        if ($el && $el.length) return $el.first();
        return null;
    }

    function injectCatalogInlineAdPlaceholderForBatch(page, $batchCards, inlineAd) {
        if (!inlineAd || !carsContainer || !carsContainer.length) return;

        const p = parseInt(String(page || '1'), 10);
        const pageNum = (Number.isFinite(p) && p >= 1) ? p : 1;

        // Only one inline ad per page
        if (carsContainer.find(`[data-ad-placement][data-ad-page="${pageNum}"]`).length) {
            return;
        }

        const $cards = ($batchCards && $batchCards.length)
            ? $batchCards.filter('.single-car').not('[data-ad-placement]')
            : carsContainer.find('.single-car').not('[data-ad-placement]');

        // Insert the ad before the 6th listing
        const $anchor = $cards.eq(5);
        if (!$anchor.length) return;

        const $ad = buildInlineAdPlaceholderElement();
        if (!$ad || !$ad.length) return;

        $ad.attr('data-ad-page', String(pageNum));
        $anchor.before($ad);
    }

    // -----------------------------
    // Back to top (Catalog)
    // -----------------------------
    const CATALOG_BACK_TO_TOP_ID = 'catalog-back-to-top';
    let $catalogBackToTop = null;

    function catalogBackToTopLabel() {
        const t = (window.catalogTranslations) ? window.catalogTranslations : {};
        const label = (t.back_to_top || '').toString().trim();
        return label || 'Back to top';
    }

    function getBackToTopShowAfterPx() {
        // Show after a "reasonable" scroll (roughly 1–1.5 screens, capped)
        const vh = Math.max(0, window.innerHeight || 0);
        const dynamic = Math.round(vh * 1.3);
        return Math.max(500, Math.min(900, dynamic || 800));
    }

    function updateCatalogBackToTopVisibility() {
        if (!$catalogBackToTop || !$catalogBackToTop.length) return;
        const y = window.scrollY || window.pageYOffset || 0;
        const show = y >= getBackToTopShowAfterPx();
        $catalogBackToTop.toggleClass('is-visible', !!show);
    }

    function scrollCatalogToTop() {
        const prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        try {
            if (!prefersReducedMotion && 'scrollBehavior' in document.documentElement.style) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                window.scrollTo(0, 0);
            }
        } catch (e) {
            try { window.scrollTo(0, 0); } catch (e2) {}
        }
    }

    function initCatalogBackToTop() {
        // Already exists
        $catalogBackToTop = $('#' + CATALOG_BACK_TO_TOP_ID);
        if (!$catalogBackToTop.length) {
            const arrowSvg = `
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M12 5l-7 7h4v7h6v-7h4l-7-7z" fill="currentColor"></path>
                </svg>
            `;
            $catalogBackToTop = $('<button/>', {
                id: CATALOG_BACK_TO_TOP_ID,
                type: 'button',
                class: 'catalog-back-to-top',
            }).html(arrowSvg);

            const label = catalogBackToTopLabel();
            $catalogBackToTop.attr('aria-label', label).attr('title', label);

            $('body').append($catalogBackToTop);
        }

        $catalogBackToTop.off('click.catalogBackToTop').on('click.catalogBackToTop', function (e) {
            e.preventDefault();
            scrollCatalogToTop();
        });

        // Keep visibility correct on resize and on initial render
        $(window).off('resize.catalogBackToTop').on('resize.catalogBackToTop', function () {
            updateCatalogBackToTopVisibility();
        });
        updateCatalogBackToTopVisibility();
    }
    
    // Clean up Selectize hidden elements
    function cleanupSelectizeHiddenElements() {
        // Remove Selectize hidden measurement elements
        $('div[style*="position: absolute"][style*="width: 0px"][style*="height: 0px"][style*="overflow: hidden"]').remove();
        $('div[aria-hidden="true"][style*="position: absolute"][style*="width: 0px"]').remove();
    }
    
    // Safety check - if required elements don't exist, don't initialize
    if (!catalogParent.length || !carsContainer.length) {
        
        return;
    }

    initCatalogBackToTop();
    
    let applyFiltersTimer = null;
    // Vehicle categories owned by this page (AJAX). Wheels/trailers are separate pages.
    const VEHICLE_CATEGORIES = ['cars', 'trucks', 'motorcycles', 'agriculture'];
    const EXTERNAL_CATALOG_CATEGORIES = ['wheels', 'trailers'];

    function isVehicleCatalogCategory(category) {
        return VEHICLE_CATEGORIES.indexOf(String(category || '')) !== -1;
    }

    function isExternalCatalogCategory(category) {
        return EXTERNAL_CATALOG_CATEGORIES.indexOf(String(category || '')) !== -1;
    }

    function cancelPendingFilterWork() {
        clearTimeout(applyFiltersTimer);
        applyFiltersTimer = null;
    }

    /**
     * Drop wheels/trailers from car-catalog filter state (localStorage pollution / race).
     * Returns a shallow copy when mutated; otherwise the original object.
     */
    function sanitizeVehicleCatalogFilters(filters) {
        if (!filters || typeof filters !== 'object') {
            return filters;
        }
        const category = String(filters.category || filters.v_type || '');
        if (!isExternalCatalogCategory(category)) {
            return filters;
        }
        const next = Object.assign({}, filters);
        delete next.category;
        delete next.v_type;
        return next;
    }

    // Common selectize configuration
    const commonSelectizeConfig = {
        plugins: ["clear_on_focus"],
        onInitialize: function() { 
            this.enable(); 
            // Clean up any existing hidden elements
            cleanupSelectizeHiddenElements();
        },
        onDestroy: function() {
            // Clean up hidden elements when selectize is destroyed
            cleanupSelectizeHiddenElements();
        },
        onChange: function (value) {
            // Handle make change to load models
            if ($(this.$input).attr('name') === 'form-catalog-brand') {
                const modelSelect = $('select[name="form-catalog-model"]')[0]?.selectize;
                if (modelSelect) {
                    modelSelect.clear(true);
                    modelSelect.clearOptions();
                    // Check if value is "all" or empty (both mean no filter)
                    if (value && value !== 'all') {
                        modelSelect.disable();
                        window.UniversalHelpers.loadModelsByMake(value); // value is now make_id
                    } else {
                        // When make is cleared or set to "all", restore "All" option from HTML and enable
                        const $originalSelect = $('select[name="form-catalog-model"]');
                        const allOption = $originalSelect.find('option[value="all"]');
                        if (allOption.length) {
                            const allText = allOption.text();
                            modelSelect.addOption({ value: 'all', text: allText });
                        }
                        modelSelect.enable();
                    }
                }
                // Update URL after make change
                setTimeout(() => updateCatalogURL(), 100);
                // Apply filters to update car list
                setTimeout(() => requestApplyFilters(), 200);
            }
            
            // Handle model change to update URL and apply filters
            if ($(this.$input).attr('name') === 'form-catalog-model') {
                // Update URL after model change
                setTimeout(() => updateCatalogURL(), 100);
                // Apply filters to update car list
                setTimeout(() => requestApplyFilters(), 200);
            }
            
            // Handle sort change to apply filters
            if ($(this.$input).attr('name') === 'form-catalog-sort') {
                requestApplyFilters();
            }
            
            // Handle all other filter changes to update car list
            const filterNames = [
                'form-catalog-price-from', 'form-catalog-price-to',
                'form-catalog-year-from', 'form-catalog-year-to',
                'form-catalog-engine-type', 'form-catalog-engine-volume-from', 'form-catalog-engine-volume-to',
                'form-catalog-power-from', 'form-catalog-power-to', 'form-catalog-gearbox',
                'form-catalog-body-type', 'form-catalog-seats', 'form-catalog-color'
            ];
            
            if (filterNames.includes($(this.$input).attr('name'))) {
                requestApplyFilters();
            }
        }
    };

    // Initialize make select with specific placeholder
    $('select[name="form-catalog-brand"]').selectize($.extend({}, commonSelectizeConfig, {
        placeholder: 'Izvēlies ražotāju'
    }));

    // Initialize model select with optgroup support (BMW series: 1. sērija, 2. sērija, ...)
    $('select[name="form-catalog-model"]').selectize($.extend({}, commonSelectizeConfig, {
        placeholder: 'Izvēlies modeli',
        optgroupField: 'optgroup',
        optgroupLabelField: 'label',
        optgroupValueField: 'id',
        // So "3" matches "3. sērija" (Sifter tokenizes so "3" does not match token "3.")
        score: function(search) {
            var query = (typeof search === 'string' ? search : (search && search.query)) || '';
            query = query.toLowerCase().trim();
            if (!query) return function() { return 1; };
            return function(item) {
                var text = (item.text || '').toLowerCase();
                if (text.indexOf(query) !== -1) return 1;
                var normalized = text.replace(/\s*\.\s*/g, ' ');
                if (normalized.indexOf(query) !== -1) return 1;
                return 0;
            };
        }
    }));

    // Initialize all other selectize instances (excluding make and model which are already initialized)
    $('.catalog-filters-selectize, .year-from-selectize, .year-to-selectize, .engine-type-selectize, .engine-volume-from-selectize, .engine-volume-to-selectize, .power-from-selectize, .power-to-selectize, .gearbox-selectize, .body-type-selectize, .seats-selectize, .color-selectize').not('select[name="form-catalog-brand"], select[name="form-catalog-model"]').selectize(commonSelectizeConfig);

    // Helper: Render car objects to HTML if needed
    function renderCarsHtml(cars) {
        if (typeof cars === 'string') return cars;
        if (!Array.isArray(cars)) return '';
        let html = '';
        const t = (window.catalogTranslations) ? window.catalogTranslations : {};
        const toBool = (value) => value === true || value === 1 || value === '1';

        // Inline SVG heart (outline by default; CSS fills when `.is-favorite` is set on the button)
        const FAVORITE_SVG = `
            <svg class="favorite-heart-icon" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path class="favorite-heart-path"
                      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linejoin="round" />
            </svg>
        `;
        const favAddLabel = t.fav_add || 'Add to favourites';
        const favRemoveLabel = t.fav_remove || 'Remove from favourites';
        cars.forEach(function(car) {
            // Image logic - use WebP with medium size for catalog listings
            let image = car.image;
            if (!image && car.thumbnail) {
                // Use medium size WebP for catalog listings
                const baseName = car.thumbnail.replace(/\.[^/.]+$/, ""); // Remove extension
                image = `/car/image/cars/${car.id}/${baseName}_medium.webp`;
            }
            if (!image) {
                image = '/assets/frontend/images/noimg.jpg';
            }
            
            // Add error handling for broken images
            const imageErrorHandler = function() {
                this.src = '/assets/frontend/images/noimg.jpg';
                this.onerror = null; // Prevent infinite loop
            };

            // Price logic - handle formatted strings with spaces
            let monthlyPrice = '';
            // Helper to parse price value (handles formatted strings like "1 049" or raw numbers)
            const parsePriceValue = (value) => {
                // Handle null, undefined, empty string, or 0
                if (value === null || value === undefined || value === '' || value === 0) return 0;
                // If it's already a number, use it directly
                if (typeof value === 'number' && !isNaN(value)) return value;
                // Convert to string, remove spaces and commas, then convert to number
                const cleanValue = String(value).replace(/\s/g, '').replace(/,/g, '');
                const numValue = Number(cleanValue);
                return isNaN(numValue) || numValue <= 0 ? 0 : numValue;
            };
            
            // Try all possible price fields in order of preference
            let finalPrice = 0;
            
            // Priority 1: Raw values (most reliable)
            if (car.price_leasing_raw) {
                finalPrice = parsePriceValue(car.price_leasing_raw);
            }
            if (finalPrice <= 0 && car.monthly_price_raw) {
                finalPrice = parsePriceValue(car.monthly_price_raw);
            }
            
            // Priority 2: Formatted values (fallback)
            if (finalPrice <= 0 && car.price_leasing) {
                finalPrice = parsePriceValue(car.price_leasing);
            }
            if (finalPrice <= 0 && car.monthly_price) {
                finalPrice = parsePriceValue(car.monthly_price);
            }
            
            // Format and display
            if (finalPrice > 0) {
                monthlyPrice = formatPriceInt(finalPrice);
            } else {
                monthlyPrice = '—';
            }
            const fullPrice = formatPrice(car.full_price || 0);

            // Seller badge (CB / CBC)
            let sellerBadgeLogo = '';

            // Check both carbuy flag and client_id for compatibility
            const isCarBuy = car.carbuy === true || car.carbuy === 1 || (car.client_id !== undefined && parseInt(car.client_id) === 0);
            const clientId = (car.client_id !== undefined && car.client_id !== null && car.client_id !== '') ? parseInt(car.client_id) : null;

            // Prefer backend-provided seller_badge, fallback to client_id checks
            let sellerBadge = (car.seller_badge || '').toString().trim().toLowerCase();
            if (sellerBadge !== 'cb' && sellerBadge !== 'cda' && sellerBadge !== 'cbc') {
                if (isCarBuy || clientId === 0) {
                    sellerBadge = 'cb';
                } else if (clientId === 16185) {
                    sellerBadge = 'cda';
                } else if (clientId === 8368) {
                    sellerBadge = 'cbc';
                } else {
                    sellerBadge = '';
                }
            }

            if (sellerBadge) {
                const extraClass = (sellerBadge === 'cbc' || sellerBadge === 'cda')
                    ? (' single-car-monthly-price-cb-logo--' + sellerBadge)
                    : '';
                const alt = sellerBadge === 'cda' ? 'CD Auto' : sellerBadge.toUpperCase();
                const ext = sellerBadge === 'cda' ? 'webp' : 'svg';
                sellerBadgeLogo = `
                    <div class="single-car-monthly-price-cb-logo${extraClass}">
                        <img src="/assets/frontend/images/${sellerBadge}.${ext}" alt="${alt}" class="object-contain position-absolute w-100 h-100 transition-default cb-logo-light-mode">
                        <img src="/assets/frontend/images/${sellerBadge}-dark-mode.${ext}" alt="${alt}" class="object-contain position-absolute w-100 h-100 transition-default cb-logo-dark-mode">
                    </div>
                `;
            }

            // Use translated fields if provided, else fallback to raw
            const gearbox = car.gearbox || '';
            const engineType = car.engine_type || '';
            const location = car.location || '';
            const displayLocation = location && location.length > 30 ? (location.slice(0, 30) + '…') : location;
            const name = car.name || (car.make + ' ' + car.model);

            // Use backend-generated slug for car detail URL
            const category = car.category || 'cars';
            const makeSlug = safeSlug(car.make || '');
            const modelSlug = safeSlug(car.model || '');
            const slug = car.slug || 'car-' + car.id; // Use backend slug or fallback
            const carUrl = `/catalog/${category}/${makeSlug}/${modelSlug}/${slug}`;

            // Determine if CarBuy car for CSS classes
            const isCarBuyClass = isCarBuy ? 'single-car-cb' : 'single-car-non-cb';
            
            const lblLeasingFrom = t.leasing_from || 'Līzings no';
            const lblPerMonth = t.per_month || '/ mēn';
            const lblFullPrice = t.full_price || 'Pilna cena';
            const lblYear = t.year || 'Izlaiduma gads:';
            const lblEngine = t.engine || 'Dzinējs:';
            const lblGearbox = t.gearbox || 'Ātrumkārba:';
            const lblLocation = t.location || 'Atrodās:';
            const lblCta = t.cta_leasing || 'Piesakies līzingam';
            const unitEuro = t.unit_euro || '€';

            // Market badges (server sends badges when fair-price engine data is available)
            let marketBadgesHtml = '';
            if (car && typeof car.badges === 'object' && car.badges !== null) {
                const badges = [];
                if (toBool(car.badges.is_new)) {
                    badges.push({ className: 'is-new', label: t.badge_new || 'New' });
                }
                if (toBool(car.badges.is_hot)) {
                    badges.push({ className: 'is-hot', label: t.badge_hot || 'Popular' });
                }
                if (toBool(car.badges.below_market)) {
                    const discountValue = Number(car.badges.discount_pct || 0);
                    const discountLabel = Number.isFinite(discountValue) && discountValue > 0
                        ? ` -${Math.round(discountValue)}%`
                        : '';
                    badges.push({
                        className: 'is-good-price',
                        label: `${t.badge_good_price || 'Good price'}${discountLabel}`,
                    });
                }
                if (toBool(car.badges.mot_fresh)) {
                    badges.push({ className: 'is-mot-fresh', label: t.badge_mot_fresh || 'Fresh MOT' });
                }

                if (badges.length > 0) {
                    marketBadgesHtml = `
                        <div class="single-car-market-badges">
                            ${badges
                                .map((badge) => `<span class="single-car-market-badge ${badge.className}">${badge.label}</span>`)
                                .join('')}
                        </div>
                    `;
                }
            }

            let cdautoWarrantyHtml = '';
            if (sellerBadge === 'cda') {
                const warrantyEyebrow = t.cdauto_warranty_eyebrow || 'Manufacturer warranty';
                const warrantyTitle = t.cdauto_warranty_title || '5 year warranty';
                const warrantyAria = t.cdauto_warranty_aria || warrantyTitle;
                cdautoWarrantyHtml = `
                    <div class="single-car-cdauto-warranty" aria-label="${warrantyAria}">
                        <svg class="single-car-cdauto-warranty__icon" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M9 1.2L15.6 3.6V9.1C15.6 13.1 13.1 16.7 9 18.4C4.9 16.7 2.4 13.1 2.4 9.1V3.6L9 1.2Z" stroke="#A63232" stroke-width="1.4" stroke-linejoin="round"/>
                            <path d="M5.8 9.4L8.1 11.7L12.4 7.2" stroke="#A63232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="single-car-cdauto-warranty__text">
                            <span class="single-car-cdauto-warranty__eyebrow">${warrantyEyebrow}</span>
                            <span class="single-car-cdauto-warranty__title">${warrantyTitle}</span>
                        </div>
                    </div>
                `;
            }

            // Fair-price position + confidence (matches PHP partial single-car card strip)
            let fairPriceRowHtml = '';
            const fp = car.fair_price;
            if (fp && typeof fp === 'object' && fp.success) {
                const pos = String(fp.market_position_label || '').trim();
                const posMap = {
                    under_market: t.market_under_short || 'Under market',
                    near_market: t.market_near_short || 'Near market',
                    over_market: t.market_over_short || 'Over market',
                };
                const label = posMap[pos] || pos;
                const conf = Math.round(Number(fp.confidence_score || 0));
                let bg = 'rgba(255,255,255,.18)';
                if (pos === 'under_market') {
                    bg = 'rgba(46, 204, 113, .30)';
                } else if (pos === 'over_market') {
                    bg = 'rgba(231, 76, 60, .30)';
                }
                const confTpl = t.market_confidence_with_value || 'Confidence: {0}%';
                const confPart = conf > 0
                    ? `<span style="display:inline-block;padding:2px 6px;border-radius:10px;background:rgba(255,255,255,.15);font-size:10px;font-weight:600;color:#fff;">${confTpl.replace('{0}', String(conf))}</span>`
                    : '';
                if (label) {
                    fairPriceRowHtml = `
                        <div style="margin-top:4px;display:flex;justify-content:flex-end;gap:4px;align-items:center;flex-wrap:wrap;">
                            <span style="display:inline-block;padding:2px 6px;border-radius:10px;background:${bg};font-size:10px;font-weight:700;color:#fff;letter-spacing:.2px;">${label}</span>
                            ${confPart}
                        </div>
                    `;
                }
            }

            const likesCountRaw = Number(car.likes_count || 0);
            const likesCount = Number.isFinite(likesCountRaw) && likesCountRaw > 0
                ? Math.floor(likesCountRaw)
                : 0;
            const likesCountClass = likesCount > 0 ? '' : ' is-empty';
            const likesCountText = likesCount > 0 ? String(likesCount) : '';

            html += `
<div class="single-car overflow-hidden default-border-radius before-animation-visibility-backface transition-default-longer ${isCarBuyClass}" data-car-id="${car.id}">
    <button type="button"
            class="favorite-toggle"
            data-car-id="${car.id}"
            data-fav-add="${favAddLabel}"
            data-fav-remove="${favRemoveLabel}"
            data-likes-count="${likesCount}"
            aria-pressed="false"
            aria-label="${favAddLabel}"
            title="${favAddLabel}">
        ${FAVORITE_SVG}
        <span class="favorite-like-count${likesCountClass}" aria-hidden="true">${likesCountText}</span>
        <span class="sr-only">${favAddLabel}</span>
    </button>
    <a href="${carUrl}" class="single-car-link" tabindex="0">
        <div class="single-car-image position-relative">
            <img src="${image}" alt="" class="absolute-cover-img" width="400" height="337" loading="lazy" decoding="async" onerror="this.src='/assets/frontend/images/noimg.jpg'; this.onerror=null;">
            ${cdautoWarrantyHtml}
            ${marketBadgesHtml}
            <div class="single-car-prices single-car-prices-common d-flex flex-nowrap justify-content-between align-items-end position-absolute">
                <div class="single-car-monthly-price radius-50-px background-white d-flex flex-wrap align-items-center">
                    ${sellerBadgeLogo}
                    <div class="single-car-monthly-price-inner">
                        <div class="single-car-monthly-price-title">${lblLeasingFrom}</div>
                        <div class="single-car-monthly-price-value font-bold default-color">
                            ${monthlyPrice} ${unitEuro} <span>${lblPerMonth}</span>
                        </div>
                    </div>
                </div>
                <div class="single-car-full-price text-right">
                    <div class="single-car-full-price-title">${lblFullPrice}</div>
                    <div class="single-car-full-price-value font-bold white-color">
                        ${fullPrice} ${unitEuro}
                    </div>
                    ${fairPriceRowHtml}
                </div>
            </div>
        </div>
        <div class="single-car-content background-white">
            <div class="single-car-content-title text-center font-bold">
                ${name}
            </div>
            <div class="single-car-content-data">
                <div class="single-car-data-row d-flex flex-wrap justify-content-between">
                    <span>${lblYear}</span>
                    <span>${car.year}</span>
                </div>
                <div class="single-car-data-row d-flex flex-wrap justify-content-between">
                    <span>${lblEngine}</span>
                    <span>${car.engine} </span>
                </div>
                <div class="single-car-data-row d-flex flex-wrap justify-content-between">
                    <span>${lblGearbox}</span>
                    <span>${gearbox}</span>
                </div>
                <div class="single-car-data-row d-flex flex-wrap justify-content-between">
                    <span>${lblLocation}</span>
                    <span>${displayLocation}</span>
                </div>
            </div>
        </div>
    </a>
    <div class="single-car-button">
        <a href="" class="center-form-modal-opener"
           data-car-id="${car.id}"
           data-car-name="${name}"
           data-car-price="${fullPrice}"
           data-car-image="${image}"
           data-seller-scope="${(parseInt(car.client_id, 10) || 0) === 0 ? 'carbuy' : 'client'}">
            ${lblCta}
        </a>
    </div>
</div>
            `;
        });
        return html;
    }

    // Helper: Trigger car appear animation for new cars
    function triggerCarAppearAnimation() {
        var $carsList = $('.cars-container');
        var $cars = $carsList.find('.single-car.before-animation-visibility-backface');
        var i = 0;
        function showNext() {
            if (i < $cars.length) {
                $cars.eq(i).removeClass('before-animation-visibility-backface');
                i++;
                setTimeout(showNext, 150);
            }
        }
        showNext();
    }

    // Variables for infinite scroll
    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;
    let currentFilters = {};
    let carsRequest = null;
    let makesRequest = null;
    let lastScrollAt = 0;
    let loadedSavedFiltersOnInit = false; // Prevent overwriting saved filters on first load
    let pendingFiltersFromStorage = null;
    const pendingAppliedByCategory = {};
    let recentSearchesRenderTimer = null;
    let recentSearchesSaveTimer = null;
    let lastTrackedMetaSearchKey = '';

    // ---- Catalog state restore (back from single-car) ----
    // We already persist catalog HTML/page/filters/scroll into sessionStorage, but we also need to restore them
    // after a full navigation (browser back or back-link) because the DOM is JS-rendered and the browser
    // cannot reliably restore scroll until content exists.
    let isRestoringCatalogState = false;
    let hasRestoredCatalogState = false;

    // Prevent browser from trying to restore scroll before we re-render the list (avoids "skip 20" race)
    try {
        if (window.history && typeof window.history.scrollRestoration !== 'undefined') {
            window.history.scrollRestoration = 'manual';
        }
    } catch (e) {}

    /**
     * Restoring cached #cars-wrapper HTML from sessionStorage on every load hides fresh server data:
     * the delayed render skips initialCarsData when .single-car already exists, so market badges / fair-price
     * never appear on first paint. Only restore list HTML on true back/forward (e.g. single car → catalog).
     */
    function shouldRestoreCatalogHtmlFromSession() {
        try {
            const entries = typeof performance !== 'undefined' ? performance.getEntriesByType('navigation') : [];
            const nav = entries && entries.length ? entries[0] : null;
            if (nav && nav.type === 'back_forward') {
                return true;
            }
        } catch (e) {}
        try {
            if (typeof performance !== 'undefined' && performance.navigation && performance.navigation.type === 2) {
                return true;
            }
        } catch (e2) {}
        return false;
    }

    function safeParseJson(raw) {
        if (!raw || typeof raw !== 'string') return null;
        try { return JSON.parse(raw); } catch (e) { return null; }
    }

    function normalizeBoolString(v, fallback = false) {
        if (v === true || v === 'true') return true;
        if (v === false || v === 'false') return false;
        return fallback;
    }

    function normalizeRestoredFilters(filters) {
        const f = (filters && typeof filters === 'object') ? Object.assign({}, filters) : {};
        // Ensure category/v_type consistency
        if (!f.category && f.v_type) f.category = f.v_type;
        if (f.category && !f.v_type) f.v_type = f.category;
        // Defaults
        if (!f.sort) f.sort = DEFAULT_FILTERS.sort;
        if (!f.seller_type) f.seller_type = DEFAULT_FILTERS.seller_type;
        return f;
    }

    function restoreCatalogScroll(targetY) {
        const y = Number(targetY);
        if (!Number.isFinite(y) || y <= 0) return;

        // Multiple attempts to combat layout shifts while images/fonts load
        const attemptScroll = (triesLeft) => {
            try { window.scrollTo(0, y); } catch (e) {}
            if (triesLeft <= 0) return;
            // If we're still off, try again next frame
            const currentY = window.scrollY || window.pageYOffset || 0;
            if (Math.abs(currentY - y) > 2) {
                requestAnimationFrame(() => attemptScroll(triesLeft - 1));
            }
        };

        requestAnimationFrame(() => attemptScroll(10));
        setTimeout(() => { try { window.scrollTo(0, y); } catch (e) {} }, 250);
        setTimeout(() => { try { window.scrollTo(0, y); } catch (e) {} }, 900);
    }

    function restoreCatalogStateFromSession(expectedFiltersKey) {
        // Only restore if we have something meaningful saved
        const cachedHtml = sessionStorage.getItem('catalogCarsHtml');
        const cachedFiltersRaw = sessionStorage.getItem('catalogFilters');
        if (!cachedHtml || !cachedFiltersRaw) return false;

        const cachedFilters = normalizeRestoredFilters(safeParseJson(cachedFiltersRaw));
        const cachedKey = getEffectiveFiltersKey(cachedFilters);
        if (expectedFiltersKey && cachedKey && expectedFiltersKey !== cachedKey) {
            return false;
        }

        // Render cached HTML immediately
        isRestoringCatalogState = true;
        hasRestoredCatalogState = true;

        try {
            carsContainer.html(cachedHtml).show();
            $(".no-results-wrapper").addClass("d-none").hide();
            if (noResultsMessage.length) noResultsMessage.hide();
            if (loadingIndicator.length) loadingIndicator.hide();
        } catch (e) {}

        // Sync favourite buttons
        try {
            if (window.CarBuyFavorites && typeof window.CarBuyFavorites.sync === 'function') {
                window.CarBuyFavorites.sync(carsContainer[0] || document);
            }
        } catch (e) {}

        // Restore pagination flags/state
        const pageRaw = sessionStorage.getItem('catalogPage');
        const hasMoreRaw = sessionStorage.getItem('catalogHasMore');
        const restoredPage = parseInt(pageRaw || '1', 10);
        currentPage = Number.isFinite(restoredPage) && restoredPage >= 1 ? restoredPage : 1;
        hasMore = normalizeBoolString(hasMoreRaw, true);
        currentFilters = cachedFilters;
        isLoading = false;

        // Sync form (including seller type radio) to restored filters so UI matches the list
        setFiltersInForm(currentFilters);

        // Note: cached HTML already includes placeholders; do not re-inject here to avoid duplicates.

        // Restore scroll after the list exists
        const scrollRaw = sessionStorage.getItem('catalogScroll');
        restoreCatalogScroll(parseInt(scrollRaw || '0', 10));

        // Allow infinite scroll again shortly after restore settles
        setTimeout(() => { isRestoringCatalogState = false; }, 700);

        // Re-run appear animation (safe if CSS already applied)
        try {
            if (typeof triggerCarAppearAnimation === 'function') {
                triggerCarAppearAnimation();
            }
            setTimeout(function() {
                $('.single-car.before-animation-visibility-backface').removeClass('before-animation-visibility-backface');
            }, 1200);
        } catch (e) {}

        return true;
    }
    
    // Helper: Debounced applyFilters
    function requestApplyFilters(delay = 200) {
        clearTimeout(applyFiltersTimer);
        applyFiltersTimer = setTimeout(applyFilters, delay);
    }

    // ---- Recent searches (last N filter states) ----
    function ensureRecentSearchesUI() {
        const $form = $('.catalog-form');
        if (!$form.length) return null;

        let $wrap = $form.find('.recent-searches--catalog');
        if ($wrap.length) return $wrap;

        const $anchor = $form.find('.filters-section-clean-wrapper');
        $wrap = $(`
            <div class="recent-searches recent-searches--catalog">
                <div class="recent-searches-header d-flex justify-content-between align-items-center">
                    <div class="recent-searches-title">${(typeof window.recentSearchesTranslations !== 'undefined' && window.recentSearchesTranslations.title) ? window.recentSearchesTranslations.title : 'Pēdējie meklējumi'}</div>
                    <button type="button" class="recent-searches-clear">${(typeof window.recentSearchesTranslations !== 'undefined' && window.recentSearchesTranslations.clear) ? window.recentSearchesTranslations.clear : 'Notīrīt'}</button>
                </div>
                <div class="recent-searches-chips" role="list"></div>
            </div>
        `);

        if ($anchor.length) {
            $anchor.after($wrap);
        } else {
            $form.append($wrap);
        }

        return $wrap;
    }

    function renderRecentSearchesCatalog() {
        const api = window.CarBuyRecentSearches;
        if (!api || typeof api.list !== 'function') return;

        const list = api.list() || [];
        const $wrap = ensureRecentSearchesUI();
        if (!$wrap) return;

        const $chips = $wrap.find('.recent-searches-chips');
        $chips.empty();

        if (!list.length) {
            $wrap.hide();
            return;
        }

        list.forEach((entry) => {
            if (!entry || !entry.key) return;
            const label = entry.label || (api.label ? api.label(entry.filters) : 'Search');
            const tooltip = (api.tooltip && entry.filters) ? api.tooltip(entry.filters) : '';
            const $chip = $(`
                <div class="recent-search-chip" role="listitem">
                    <button type="button" class="recent-search-chip-btn" data-recent-key=""></button>
                    <button type="button" class="recent-search-chip-remove" aria-label="Remove" data-recent-key="">×</button>
                </div>
            `);
            $chip
                .find('.recent-search-chip-btn')
                .attr('data-recent-key', entry.key)
                .attr('title', tooltip || label)
                .text(label);
            $chip.find('.recent-search-chip-remove').attr('data-recent-key', entry.key);
            $chips.append($chip);
        });

        $wrap.show();
    }

    function scheduleRenderRecentSearchesCatalog(delay = 50) {
        clearTimeout(recentSearchesRenderTimer);
        recentSearchesRenderTimer = setTimeout(renderRecentSearchesCatalog, delay);
    }

    // Prevent spamming the list while user is still typing/changing filters:
    // save only after short inactivity AND only if filters didn't change in-between.
    function scheduleSaveRecentSearch(filters, delay = 1200) {
        const api = window.CarBuyRecentSearches;
        if (!api || typeof api.upsert !== 'function' || typeof api.key !== 'function') return;

        // Only save meaningful searches: require make + model.
        // (Prevents saving on initial load or after selecting only make.)
        const hasMake = !!(filters && (filters.make_id || filters.make_name || filters.make));
        const hasModel = !!(filters && (filters.model_id || filters.model_name || filters.model));
        if (!hasMake || !hasModel) return;

        const snapshotKey = api.key(filters);
        if (!snapshotKey) return;

        clearTimeout(recentSearchesSaveTimer);
        recentSearchesSaveTimer = setTimeout(() => {
            try {
                const currentKey = api.key(currentFilters);
                if (currentKey !== snapshotKey) return;
                api.upsert(currentFilters);
                scheduleRenderRecentSearchesCatalog(0);
            } catch (e) {}
        }, delay);
    }

    function applyRecentSearchToCatalog(filters) {
        if (!filters) return;

        const category = filters.category || filters.v_type || getActiveCategory() || 'cars';

        // Reset ALL filter fields first so we don't carry over old values
        // (e.g. previous body_type=sedan leaking into the next search)
        const $form = $('.catalog-form');
        if ($form.length) {
            // Clear numeric inputs
            $form.find('[name="form-catalog-price-from"]').val('');
            $form.find('[name="form-catalog-price-to"]').val('');

            // Reset selects to "all" (or empty if no all-option)
            const selectNames = [
                'form-catalog-brand',
                'form-catalog-model',
                'form-catalog-year-from',
                'form-catalog-year-to',
                'form-catalog-engine-type',
                'form-catalog-engine-volume-from',
                'form-catalog-engine-volume-to',
                'form-catalog-power-from',
                'form-catalog-power-to',
                'form-catalog-gearbox',
                'form-catalog-body-type',
                'form-catalog-seats',
                'form-catalog-color',
            ];
            selectNames.forEach((name) => {
                const el = $form.find(`[name="${name}"]`)[0];
                if (!el) return;
                const hasAllOption = $(el).find('option[value="all"]').length > 0;
                const valueToSet = hasAllOption ? 'all' : '';
                if (el.selectize) {
                    el.selectize.setValue(valueToSet, true);
                    el.selectize.enable();
                } else {
                    $(el).val(valueToSet);
                }
            });

            // Reset sort to default
            const sortEl = $form.find('[name="form-catalog-sort"]')[0];
            if (sortEl && sortEl.selectize) {
                sortEl.selectize.setValue('latest', true);
            } else {
                $form.find('[name="form-catalog-sort"]').val('latest');
            }

            // Reset seller type
            $form.find('input[name="form-catalog-seller-type"][value="' + DEFAULT_FILTERS.seller_type + '"]').prop('checked', true);
        }

        // Ensure correct category is active
        $('.catalog-filters-non-dropdown-link').removeClass('active');
        $(`.catalog-filters-non-dropdown-link[data-category="${category}"]`).addClass('active');

        // Apply category-specific filter visibility (same behavior as category click)
        const $bodyTypeWrapper = $('.single-filter-wrapper[data-filter-type="body-type"]');
        const $seatsWrapper = $('.single-filter-wrapper[data-filter-type="seats"]');
        const $gearboxWrapper = $('.single-filter-wrapper[data-filter-type="gearbox"]');
        if (category === 'trucks') {
            $bodyTypeWrapper.hide();
            $seatsWrapper.hide();
            $gearboxWrapper.show();
        } else if (category === 'motorcycles') {
            $bodyTypeWrapper.hide();
            $seatsWrapper.hide();
            $gearboxWrapper.hide();
        } else if (category === 'agriculture') {
            $bodyTypeWrapper.hide();
            $seatsWrapper.hide();
            $gearboxWrapper.show();
        } else {
            $bodyTypeWrapper.show();
            $seatsWrapper.show();
            $gearboxWrapper.show();
        }

        // Keep a pending snapshot so make/model are applied after makes are fetched
        pendingFiltersFromStorage = Object.assign({}, filters, { category, v_type: category });
        pendingAppliedByCategory[category] = false;

        // Set all non-make/model fields right away
        const withoutMakeModel = Object.assign({}, pendingFiltersFromStorage);
        delete withoutMakeModel.make_id;
        delete withoutMakeModel.model_id;
        delete withoutMakeModel.make;
        delete withoutMakeModel.model;
        delete withoutMakeModel.make_name;
        delete withoutMakeModel.model_name;
        delete withoutMakeModel.make_slug;
        delete withoutMakeModel.model_slug;
        setFiltersInForm(withoutMakeModel);

        // Ensure filters panel is visible so user understands what happened
        if (hasSelectedFilters()) {
            openFiltersSection();
        }

        // Fetch makes for this category, then pending make/model will be applied
        try { fetchMakesForCategory(category); } catch (e) {}

        // Trigger apply (it will run again after make/model is set)
        requestApplyFilters(200);
        setTimeout(() => { requestApplyFilters(0); }, 900);
    }

    // Helper: Get default filter values
    const DEFAULT_FILTERS = {
        sort: 'latest',
        seller_type: 'carbuy',
    };

    let focusedCarIds = [];

    const NOTIFICATION_FILTER_QUERY_KEYS = [
        'make_id',
        'model_id',
        'manufacturer_id',
        'price_from',
        'price_to',
        'year_from',
        'year_to',
        'engine_type',
        'engine_volume_from',
        'engine_volume_to',
        'power_from',
        'power_to',
        'gearbox',
        'body_type',
        'seats',
        'color',
        'sort',
        'seller_type',
        'query',
    ];

    function parseNotificationIdList(raw) {
        if (raw === null || raw === undefined || raw === '') {
            return [];
        }
        const parts = String(raw).split(',');
        const ids = [];
        const seen = {};
        parts.forEach(function (part) {
            const id = parseInt(String(part).trim(), 10);
            if (!Number.isFinite(id) || id <= 0 || seen[id]) {
                return;
            }
            seen[id] = true;
            ids.push(id);
        });
        return ids.slice(0, 120);
    }

    function parseNotificationFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const ids = parseNotificationIdList(params.get('ids') || params.get('car_ids'));
        if (ids.length > 0) {
            return { mode: 'ids', ids: ids };
        }

        const filters = {};
        NOTIFICATION_FILTER_QUERY_KEYS.forEach(function (key) {
            const value = params.get(key);
            // "all" is a wildcard for every filter except seller_type, where it is a real source.
            const isWildcard = String(value) === 'all' && key !== 'seller_type';
            if (value !== null && String(value).trim() !== '' && !isWildcard) {
                filters[key] = String(value).trim();
            }
        });

        if (Object.keys(filters).length === 0) {
            return null;
        }

        const category = getActiveCategory();
        if (category) {
            filters.category = category;
            filters.v_type = category;
        }
        if (!filters.sort) {
            filters.sort = DEFAULT_FILTERS.sort;
        }
        if (filters.manufacturer_id && !filters.make_id) {
            filters.make_id = filters.manufacturer_id;
        }
        delete filters.manufacturer_id;

        return { mode: 'filters', filters: filters };
    }

    function cleanNotificationIdsFromUrl() {
        try {
            const url = new URL(window.location.href);
            url.searchParams.delete('ids');
            url.searchParams.delete('car_ids');
            const search = url.searchParams.toString();
            window.history.replaceState({}, '', url.pathname + (search ? '?' + search : '') + (url.hash || ''));
        } catch (e) {}
    }

    function showNotificationCarsBanner() {
        const $banner = $('.catalog-notification-cars-banner');
        if ($banner.length) {
            $banner.removeClass('d-none').show();
        }
    }

    function hideNotificationCarsBanner() {
        const $banner = $('.catalog-notification-cars-banner');
        if ($banner.length) {
            $banner.addClass('d-none').hide();
        }
    }

    function loadFocusedNotificationCars() {
        if (!focusedCarIds.length) {
            return;
        }

        isLoading = true;
        currentPage = 1;
        hasMore = false;
        currentFilters = {
            ids: focusedCarIds.join(','),
            sort: DEFAULT_FILTERS.sort,
            seller_type: 'all',
        };

        loadingIndicator.show();
        carsContainer.hide();
        noResultsMessage.hide();
        $('.no-results-wrapper').addClass('d-none').hide();

        saveFiltersToServer(currentFilters, function () {
            loadCars();
        });
    }

    function clearNotificationFocusedCars(reapply) {
        focusedCarIds = [];
        hideNotificationCarsBanner();
        cleanNotificationIdsFromUrl();
        if (reapply !== false) {
            requestApplyFilters(0);
        }
    }

    $(document).on('click', '.catalog-notification-cars-show-all', function (e) {
        e.preventDefault();
        clearNotificationFocusedCars(true);
    });

    function isValidCatalogSellerType(value) {
        return value === 'carbuy' || value === 'cdauto' || value === 'carbuyclub' || value === 'all';
    }

    // Helper: stable key for comparing "effective" filters (prevents duplicate loads)
    const EFFECTIVE_FILTER_KEYS = [
        'category',
        'v_type',
        'make_id',
        'model_id',
        'price_from',
        'price_to',
        'year_from',
        'year_to',
        'engine_type',
        'engine_volume_from',
        'engine_volume_to',
        'power_from',
        'power_to',
        'gearbox',
        'body_type',
        'seats',
        'color',
        'sort',
        'seller_type',
        'ids',
    ];

    function getEffectiveFiltersKey(filters) {
        const src = filters || {};
        const normalized = {};

        // Keep only effective keys, normalize empty values, and ensure defaults exist.
        EFFECTIVE_FILTER_KEYS.forEach((key) => {
            const value = src[key];
            if (value === '' || value === null || value === undefined) return;
            normalized[key] = value;
        });
        if (!normalized.sort) normalized.sort = DEFAULT_FILTERS.sort;
        if (!normalized.seller_type) normalized.seller_type = DEFAULT_FILTERS.seller_type;

        // Stable stringify (sorted keys)
        const out = {};
        Object.keys(normalized).sort().forEach((k) => { out[k] = normalized[k]; });
        return JSON.stringify(out);
    }
    
    // Cookie helpers for remembering filters panel open/closed state
    const FILTERS_OPEN_COOKIE = 'carbuy_catalog_filters_open';
    function getFiltersOpenCookie() {
        const match = document.cookie.match(new RegExp('(?:^|; )' + FILTERS_OPEN_COOKIE + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
    }
    function setFiltersOpenCookie(open) {
        const value = open ? '1' : '0';
        document.cookie = FILTERS_OPEN_COOKIE + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=Lax';
    }

    function getVehicleCategoryFromPath() {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        if (pathParts[0] !== 'catalog' || !pathParts[1]) {
            return '';
        }
        return isVehicleCatalogCategory(pathParts[1]) ? pathParts[1] : '';
    }

    // Helper: Get active category from tab or URL
    function getActiveCategory() {
        let category = $('.catalog-filters-non-dropdown-link.active').data('category');
        // Ignore Diski/Piekabes if they were wrongly marked active before navigation.
        if (isExternalCatalogCategory(category)) {
            category = '';
        }
        if (!category) {
            category = getVehicleCategoryFromPath();
        }
        if (category === 'newest') return 'cars';
        if (!isVehicleCatalogCategory(category)) {
            return 'cars';
        }
        return category;
    }
    
    // Helper: CSRF token resolution
    function getCsrf() {
        let name = 'carbuy_csrf';
        let value = '';
        if (window.CSRFHelper && typeof window.CSRFHelper.getCSRFData === 'function') {
            try {
                const data = window.CSRFHelper.getCSRFData();
                if (data && data.name && data.value) {
                    name = data.name;
                    value = data.value;
                }
            } catch (e) {}
        }
        if (!value) {
            const metaTag = $('meta[name="carbuy_csrf"]');
            if (metaTag.length) {
                value = metaTag.attr('content');
            } else {
                const formInput = $('input[name="carbuy_csrf"]');
                if (formInput.length) value = formInput.val();
            }
        }
        return { name, value };
    }
    
    // Helper: Safe slug
    function safeSlug(str) {
        if (!str) return '';
        return String(str)
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
    }
    
    // Helper: get select value preferring Selectize, converting "all" to empty string
    function getSelectValue(name) {
        const sel = $(`[name="${name}"]`)[0]?.selectize;
        let value = '';
        if (sel) {
            value = sel.getValue() || '';
        } else {
            value = $(`[name="${name}"]`).val() || '';
        }
        // Convert "all" to empty string for backend compatibility
        return (value === 'all') ? '' : value;
    }

    // Helper: determine if any non-default filters are selected
    function hasSelectedFilters() {
        const makeId = getSelectValue('form-catalog-brand');
        const modelId = getSelectValue('form-catalog-model');
        const priceFrom = $('[name="form-catalog-price-from"]').val();
        const priceTo = $('[name="form-catalog-price-to"]').val();
        const yearFrom = $('[name="form-catalog-year-from"]').val();
        const yearTo = $('[name="form-catalog-year-to"]').val();
        const engineType = getSelectValue('form-catalog-engine-type');
        const engineVolumeFrom = getSelectValue('form-catalog-engine-volume-from');
        const engineVolumeTo = getSelectValue('form-catalog-engine-volume-to');
        const powerFrom = getSelectValue('form-catalog-power-from');
        const powerTo = getSelectValue('form-catalog-power-to');
        const gearbox = getSelectValue('form-catalog-gearbox');
        const bodyType = getSelectValue('form-catalog-body-type');
        const seats = getSelectValue('form-catalog-seats');
        const color = getSelectValue('form-catalog-color');
        const sort = getSelectValue('form-catalog-sort');
        const sellerType = $('input[name="form-catalog-seller-type"]:checked').val() || DEFAULT_FILTERS.seller_type;
        return !!(
            makeId || modelId || priceFrom || priceTo || yearFrom || yearTo ||
            engineType || engineVolumeFrom || engineVolumeTo || powerFrom || powerTo ||
            gearbox || bodyType || seats || color ||
            (sort && sort !== DEFAULT_FILTERS.sort) ||
            (sellerType && sellerType !== DEFAULT_FILTERS.seller_type)
        );
    }

    // Helper: open filters section programmatically
    function openFiltersSection() {
        const $filtersSection = $('.filters-section');
        $filtersSection.css('display', '').addClass('filters-open').show();
        const $filterButton = $('.catalog-filters-dropdown .catalog-filters-dropdown-link');
        $filterButton.addClass('opened-filters active');
        $filterButton.find('.close-hidden').addClass('d-block');
        setFiltersOpenCookie(true);
    }
    
    // Infinite scroll event handler (optimized throttling + debouncing)
    let scrollTimeout = null;
    $(window).on('scroll', function() {
        // During restore we must not load page 2 before page 1 is rendered (causes "skips latest 20")
        if (isRestoringCatalogState) { return; }
        const now = Date.now();
        // Increased throttle from 200ms to 500ms for better performance
        if (now - lastScrollAt < 500) { return; }
        lastScrollAt = now;
        
        // Clear existing timeout (debouncing)
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        
        // Debounce: wait 300ms after user stops scrolling before checking
        scrollTimeout = setTimeout(function() {
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const currentPosition = scrollTop + windowHeight;

            // Compute bottom of the cars list container rather than full document
            const $list = $('#cars-wrapper');
            if (!$list.length) { return; }
            const listBottom = $list.offset().top + $list.outerHeight();
            const preload = 300; // Increased from 200 to 300 for better UX
            const threshold = listBottom - preload;

            if (currentPosition >= threshold) {
                // Do not load more if we haven't rendered any cars yet (prevents page=2 first render)
                const hasAnyCars = carsContainer.find('.single-car').length > 0;
                if (hasAnyCars && !isLoading && hasMore) {
                    loadMoreCars();
                }
            }
        }, 300); // 300ms debounce delay
    });


    // Helper to set form values from filters object
    function setFiltersInForm(filters) {
        if (!filters) return;
        filters = sanitizeVehicleCatalogFilters(filters);

        // Set category tab (vehicle categories only — never Diski/Piekabes)
        if (filters.category && isVehicleCatalogCategory(filters.category)) {
            $('.catalog-filters-non-dropdown-link').removeClass('active');
            $(`.catalog-filters-non-dropdown-link[data-category="${filters.category}"]`).addClass('active');
        }
        
        // Set v_type (vehicle type) - this is the same as category for filtering
        if (filters.category && isVehicleCatalogCategory(filters.category) && !filters.v_type) {
            // If category is set but v_type is not, set v_type to match category
            filters.v_type = filters.category;
        }
        
        // Set make (brand) - try ID first, then name if ID not available
        if (filters.make_id) {
            const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
            if (makeSelect) {
                makeSelect.setValue(filters.make_id);
                
                // If we have a saved model, load models for this make and then set the model
                if (filters.model_id) {
                    setTimeout(() => {
                        const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
                        if (modelSelect) {
                            modelSelect.setValue(filters.model_id);
                        }
                    }, 500); // Wait for models to load
                }
            } else {
                $('[name="form-catalog-brand"]').val(filters.make_id).trigger('change', [true]);
            }
        } else if (filters.make) {
            // If we have make name but no ID, try to find ID by matching name
            const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
            if (makeSelect && makeSelect.options) {
                const makeName = filters.make.toLowerCase();
                for (const [id, option] of Object.entries(makeSelect.options)) {
                    if (option.text && option.text.toLowerCase() === makeName) {
                        makeSelect.setValue(id);
                        filters.make_id = id; // Update filters with ID
                        // If we have model name, load models and find model
                        if (filters.model && !filters.model_id) {
                            setTimeout(() => {
                                const maybePromise = window.UniversalHelpers.loadModelsByMake(id);
                                const applyModel = () => {
                                    setTimeout(() => {
                                        const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
                                        if (modelSelect && modelSelect.options) {
                                            const modelName = filters.model.toLowerCase();
                                            for (const [modelId, modelOption] of Object.entries(modelSelect.options)) {
                                                if (modelOption.text && modelOption.text.toLowerCase() === modelName) {
                                                    modelSelect.setValue(modelId);
                                                    filters.model_id = modelId; // Update filters with ID
                                                    try { localStorage.setItem('catalog_filters', JSON.stringify(filters)); } catch (e) {}
                                                    break;
                                                }
                                            }
                                        }
                                    }, 300);
                                };
                                if (maybePromise && typeof maybePromise.then === 'function') {
                                    maybePromise.then(applyModel);
                                } else {
                                    applyModel();
                                }
                            }, 100);
                        }
                        break;
                    }
                }
            }
        }
        
        // Set model - use Selectize API if available (only if make was not set above)
        if (filters.model_id && !filters.make_id) {
            const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
            if (modelSelect) {
                modelSelect.setValue(filters.model_id);
            } else {
                $('[name="form-catalog-model"]').val(filters.model_id).trigger('change', [true]);
            }
        }
        
        // Set other filter fields (use Selectize API for dropdowns)
        if (filters.price_from) $('[name="form-catalog-price-from"]').val(filters.price_from);
        if (filters.price_to) $('[name="form-catalog-price-to"]').val(filters.price_to);
        if (filters.year_from) {
            const yearFromSelect = $('[name="form-catalog-year-from"]')[0]?.selectize;
            if (yearFromSelect) {
                yearFromSelect.setValue(filters.year_from);
            } else {
                $('[name="form-catalog-year-from"]').val(filters.year_from);
            }
        }
        if (filters.year_to) {
            const yearToSelect = $('[name="form-catalog-year-to"]')[0]?.selectize;
            if (yearToSelect) {
                yearToSelect.setValue(filters.year_to);
            } else {
                $('[name="form-catalog-year-to"]').val(filters.year_to);
            }
        }
        if (filters.engine_type) {
            const engineTypeSelect = $('[name="form-catalog-engine-type"]')[0]?.selectize;
            if (engineTypeSelect) {
                engineTypeSelect.setValue(filters.engine_type);
            } else {
                $('[name="form-catalog-engine-type"]').val(filters.engine_type);
            }
        }
        // Handle engine volume (backward compatibility: if engine_volume exists, use it for both from/to)
        if (filters.engine_volume_from || filters.engine_volume) {
            const engineVolumeFromSelect = $('[name="form-catalog-engine-volume-from"]')[0]?.selectize;
            const value = filters.engine_volume_from || filters.engine_volume;
            if (engineVolumeFromSelect) {
                engineVolumeFromSelect.setValue(value);
            } else {
                $('[name="form-catalog-engine-volume-from"]').val(value);
            }
        }
        if (filters.engine_volume_to) {
            const engineVolumeToSelect = $('[name="form-catalog-engine-volume-to"]')[0]?.selectize;
            if (engineVolumeToSelect) {
                engineVolumeToSelect.setValue(filters.engine_volume_to);
            } else {
                $('[name="form-catalog-engine-volume-to"]').val(filters.engine_volume_to);
            }
        }
        // Handle power (backward compatibility: if power exists, use it for both from/to)
        if (filters.power_from || filters.power) {
            const powerFromSelect = $('[name="form-catalog-power-from"]')[0]?.selectize;
            const value = filters.power_from || filters.power;
            if (powerFromSelect) {
                powerFromSelect.setValue(value);
            } else {
                $('[name="form-catalog-power-from"]').val(value);
            }
        }
        if (filters.power_to) {
            const powerToSelect = $('[name="form-catalog-power-to"]')[0]?.selectize;
            if (powerToSelect) {
                powerToSelect.setValue(filters.power_to);
            } else {
                $('[name="form-catalog-power-to"]').val(filters.power_to);
            }
        }
        if (filters.gearbox) {
            const gearboxSelect = $('[name="form-catalog-gearbox"]')[0]?.selectize;
            if (gearboxSelect) {
                gearboxSelect.setValue(filters.gearbox);
            } else {
                $('[name="form-catalog-gearbox"]').val(filters.gearbox);
            }
        }
        if (filters.body_type) {
            const bodyTypeSelect = $('[name="form-catalog-body-type"]')[0]?.selectize;
            if (bodyTypeSelect) {
                bodyTypeSelect.setValue(filters.body_type);
            } else {
                $('[name="form-catalog-body-type"]').val(filters.body_type);
            }
        }
        if (filters.seats) {
            const seatsSelect = $('[name="form-catalog-seats"]')[0]?.selectize;
            if (seatsSelect) {
                seatsSelect.setValue(filters.seats);
            } else {
                $('[name="form-catalog-seats"]').val(filters.seats);
            }
        }
        if (filters.color) {
            const colorSelect = $('[name="form-catalog-color"]')[0]?.selectize;
            if (colorSelect) {
                colorSelect.setValue(filters.color);
            } else {
                $('[name="form-catalog-color"]').val(filters.color);
            }
        }
        
        // Set sort - use Selectize API if available
        if (filters.sort) {
            const sortSelect = $('[name="form-catalog-sort"]')[0]?.selectize;
            if (sortSelect) {
                sortSelect.setValue(filters.sort);
            } else {
                $('[name="form-catalog-sort"]').val(filters.sort);
            }
        }
        
        // Set seller type radio button (always enforce a valid default)
        const sellerTypeRaw = (filters && filters.seller_type) ? filters.seller_type : '';
        const sellerType = isValidCatalogSellerType(sellerTypeRaw)
            ? sellerTypeRaw
            : DEFAULT_FILTERS.seller_type;
        $('input[name="form-catalog-seller-type"][value="' + sellerType + '"]').prop('checked', true);
        // Beta: sync seller-type toggle buttons if present
        const $toggleWrap = $('.catalog-page .catalog-seller-type-toggle');
        if ($toggleWrap.length) {
            $toggleWrap.find('.seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
            $toggleWrap.find('.seller-type-toggle-btn[data-seller-type="' + sellerType + '"]').addClass('active').attr('aria-pressed', 'true');
        }
    }

    // Helper to save filters to localStorage
    function saveFiltersToServer(filters, callback) {
        // Store filters in localStorage with consistent key
        try {
            localStorage.setItem('catalog_filters', JSON.stringify(filters));
            
        } catch (e) {
            
        }
        
        // Execute callback immediately since localStorage is synchronous
        if (callback && typeof callback === 'function') {
            callback();
        }
    }

    // On page load: collapsed by default, or restore state from cookie (hash #open-filters overrides)
    $(document).ready(function() {
        var $filtersSection = $(".filters-section");
        var $filterButton = $('.catalog-filters-dropdown .catalog-filters-dropdown-link');
        if (window.location.hash === '#open-filters') {
            $filtersSection.css('display', '').addClass('filters-open').show();
            $filterButton.addClass('opened-filters active');
            $filterButton.find('.close-hidden').addClass('d-block');
            setFiltersOpenCookie(true);
            $('html, body').animate({ scrollTop: $filtersSection.offset().top - 40 }, 500);
        } else {
            var remembered = getFiltersOpenCookie();
            if (remembered === '1') {
                $filtersSection.css('display', '').addClass('filters-open').show();
                $filterButton.addClass('opened-filters active');
                $filterButton.find('.close-hidden').addClass('d-block');
            } else {
                $filtersSection.hide().removeClass('filters-open');
                $filterButton.removeClass('opened-filters active');
                $filterButton.find('.close-hidden').removeClass('d-block');
                setFiltersOpenCookie(false);
            }
        }
        
        // Load saved filters - prefer localStorage (fresh data) over backend session (may be stale)
        setTimeout(() => {
            let filters = null;
            let filterSource = '';

            const notificationFromUrl = parseNotificationFromUrl();
            if (notificationFromUrl && notificationFromUrl.mode === 'ids') {
                focusedCarIds = notificationFromUrl.ids.slice();
                showNotificationCarsBanner();
                loadFocusedNotificationCars();
                return;
            }

            if (notificationFromUrl && notificationFromUrl.mode === 'filters') {
                filters = notificationFromUrl.filters;
                filterSource = 'notification-url';
            } else {
            // First priority: Load from localStorage (most recent data from home form)
            const savedFilters = localStorage.getItem('catalog_filters');
            if (savedFilters) {
                try {
                    filters = sanitizeVehicleCatalogFilters(JSON.parse(savedFilters));
                    filterSource = 'localStorage';
                    // Rewrite polluted wheels/trailers category so other tabs stop replaying it.
                    try {
                        localStorage.setItem('catalog_filters', JSON.stringify(filters));
                    } catch (e) {}
                } catch (e) {
                    // Failed to parse localStorage filters
                }
            }
            
            // Fallback: Use backend saved filters if localStorage doesn't have category
            if ((!filters || !filters.category) && window.catalogSavedFilters && Object.keys(window.catalogSavedFilters).length > 0) {
                filters = sanitizeVehicleCatalogFilters(window.catalogSavedFilters);
                filterSource = 'backend-session';
            }
            }

            // An explicit category URL is authoritative. A stale localStorage category must not
            // switch the highlighted tab or replace the server-rendered category after page load.
            const routeCategory = getVehicleCategoryFromPath();
            if (routeCategory) {
                const storedCategory = filters && (filters.category || filters.v_type);
                if (storedCategory && storedCategory !== routeCategory) {
                    filters = {
                        category: routeCategory,
                        v_type: routeCategory,
                        sort: filters.sort || DEFAULT_FILTERS.sort,
                        seller_type: filters.seller_type || DEFAULT_FILTERS.seller_type,
                    };
                    filterSource = 'url-category';
                } else {
                    filters = filters || {};
                    filters.category = routeCategory;
                    filters.v_type = routeCategory;
                }
                try {
                    localStorage.setItem('catalog_filters', JSON.stringify(filters));
                } catch (e) {}
            }
            
            // If we have make/model names but no IDs, we need to resolve them later
            // This happens when filters come from home form which sends names
            // We'll resolve them after makes/models are loaded (handled in setFiltersInForm when makes are available)
            
            // If no saved filters but category is in URL, initialize filters with category
            if (!filters || !filters.category) {
                const urlCategory = getActiveCategory();
                if (urlCategory && isVehicleCatalogCategory(urlCategory)) {
                    filters = filters || {};
                    filters.category = urlCategory;
                    filters.v_type = urlCategory; // Set v_type to match category
                    filterSource = 'url-category';
                    // Save to localStorage for consistency
                    try {
                        localStorage.setItem('catalog_filters', JSON.stringify(filters));
                    } catch (e) {}
                }
            }
            
            if (filters && Object.keys(filters).length > 0) {
                pendingFiltersFromStorage = filters;
                setFiltersInForm(filters);
                // Mark that we loaded saved filters to avoid immediate overwrite by initial apply
                if (filterSource === 'localStorage' || filterSource === 'backend-session' || filterSource === 'notification-url') {
                    loadedSavedFiltersOnInit = true;
                }
                
                // Ensure filters are visible only if there are non-default selections (and user did not leave them closed)
                if (hasSelectedFilters() && getFiltersOpenCookie() !== '0') {
                    openFiltersSection();
                }
            }
            
            // If no saved filters but there are any selected in DOM, open filters (unless user left them closed)
            if (!filters && hasSelectedFilters() && getFiltersOpenCookie() !== '0') {
                openFiltersSection();
            }

            // Ensure makes are loaded on page load for current category if empty
            const makeSel = $('[name="form-catalog-brand"]')[0]?.selectize;
            const hasMakeOptions = makeSel ? (Object.keys(makeSel.options || {}).length > 0) : ($('[name="form-catalog-brand"] option').length > 1);
            const initialCategory = getActiveCategory();
            if (!hasMakeOptions) {
                if (initialCategory) {
                    fetchMakesForCategory(initialCategory);
                }
            } else if (pendingFiltersFromStorage && pendingFiltersFromStorage.category) {
                try { tryApplyPendingMakeModel(pendingFiltersFromStorage); } catch (e) {}
            }
            // If filters are hidden, ensure toggle button classes are not active
            const $filtersSection = $('.filters-section');
            if (!$filtersSection.is(':visible')) {
                $('.catalog-filters-dropdown .catalog-filters-dropdown-link').removeClass('opened-filters active');
                $('.catalog-filters-dropdown .catalog-filters-dropdown-link .close-hidden').removeClass('d-block');
            }
            // Session storage reuse disabled to avoid stale results across filters/locale

            // Restore car list + pagination + scroll from sessionStorage if available (back/forward only).
            // This fixes: (1) scroll position not restored after viewing a single car
            // and (2) page-2 loading first (skipping latest 20) due to early scroll triggers.
            try {
                if (shouldRestoreCatalogHtmlFromSession()) {
                    const expectedKey = getEffectiveFiltersKey(filters || {});
                    restoreCatalogStateFromSession(expectedKey);
                }
            } catch (e) {}

            // Always load cars on initial page load - either apply filters or load default cars
            // Wait a bit for filters to be set in form, then load cars
            setTimeout(function() {
                // Check if cars are already visible (from server-side render)
                const hasCarsInContainer = carsContainer.length && carsContainer.find('.single-car').length > 0;
                const isBackForwardNav = shouldRestoreCatalogHtmlFromSession();
                const canReuseExistingCards = isBackForwardNav && hasCarsInContainer;
                
                // If no cars are visible, try to render initial cars from server or load via AJAX
                if (!canReuseExistingCards) {
                    if (filterSource === 'notification-url') {
                        requestApplyFilters(0);
                        return;
                    }

                    // If stored filters use a non-default seller source, server initial data is CarBuy-only; fetch so list and form match.
                    const storedSellerType = (pendingFiltersFromStorage && pendingFiltersFromStorage.seller_type) ? pendingFiltersFromStorage.seller_type : '';
                    if (isValidCatalogSellerType(storedSellerType) && storedSellerType !== DEFAULT_FILTERS.seller_type) {
                        requestApplyFilters(0);
                        return;
                    }

                    // Check if we have initial cars data from server (CarBuy by default)
                    if (window.initialCarsData && window.initialCarsData.cars && window.initialCarsData.cars.length > 0) {
                        // Render initial cars from server-side data
                        const html = renderCarsHtml(window.initialCarsData.cars);
                        if (html) {
                            carsContainer.html(html).show();

                            // Sync favourite buttons for freshly rendered cards
                            try {
                                if (window.CarBuyFavorites && typeof window.CarBuyFavorites.sync === 'function') {
                                    window.CarBuyFavorites.sync(carsContainer[0] || document);
                                }
                            } catch (e) {}

                            currentPage = window.initialCarsData.currentPage || 1;
                            hasMore = window.initialCarsData.hasMore || false;
                            const activeCategory = getActiveCategory();
                            currentFilters = {
                                category: activeCategory,
                                v_type: activeCategory,
                                sort: DEFAULT_FILTERS.sort,
                                seller_type: (pendingFiltersFromStorage && isValidCatalogSellerType(pendingFiltersFromStorage.seller_type)) ? pendingFiltersFromStorage.seller_type : DEFAULT_FILTERS.seller_type
                            };
                            setFiltersInForm(currentFilters);
                            
                            // Trigger car appear animation
                            if (typeof triggerCarAppearAnimation === 'function') {
                                triggerCarAppearAnimation();
                            }

                            try { injectCatalogInlineAdPlaceholderForBatch(currentPage, carsContainer.children('.single-car'), window.initialCarsData.inlineAd === true); } catch (e) {}
                            
                            // Update sessionStorage
                            try {
                                sessionStorage.setItem('catalogCarsHtml', carsContainer.html());
                                sessionStorage.setItem('catalogPage', String(currentPage));
                                sessionStorage.setItem('catalogHasMore', String(hasMore));
                                sessionStorage.setItem('catalogFilters', JSON.stringify(currentFilters || {}));
                                touchCatalogSessionLang();
                            } catch (e) {}
                        } else {
                            // No cars in initial data, load via AJAX
                requestApplyFilters(0);
            }
                    } else {
                        // No initial cars data, load via AJAX
                        requestApplyFilters(0);
                    }
                }
            }, 300);
        }, 200);
    });

    // Keep scroll position updated during browsing
    $(window).on('scroll', function() {
        try { sessionStorage.setItem('catalogScroll', String(window.scrollY || window.pageYOffset || 0)); } catch (e) {}
        updateCatalogBackToTopVisibility();
    });

    // When filters are changed or applied, save them to the server
    function applyFilters() {
        // Safety check - ensure required elements exist
        if (!carsContainer.length || !loadingIndicator.length) {
            return;
        }

        if (focusedCarIds.length > 0) {
            focusedCarIds = [];
            hideNotificationCarsBanner();
            cleanNotificationIdsFromUrl();
        }
        
        if (isLoading) {
            return;
        }
        
        // Collect all filter values with proper Selectize integration (do not mutate state yet)
        const activeCategory = getActiveCategory();
        if (!isVehicleCatalogCategory(activeCategory)) {
            return;
        }
        const nextFilters = {
            category: activeCategory,
            v_type: activeCategory, // Set v_type to match category for backend filtering
            make_id: getSelectValue('form-catalog-brand'),
            model_id: getSelectValue('form-catalog-model'),
            price_from: $('[name="form-catalog-price-from"]').val() || '',
            price_to: $('[name="form-catalog-price-to"]').val() || '',
            year_from: $('[name="form-catalog-year-from"]').val() || '',
            year_to: $('[name="form-catalog-year-to"]').val() || '',
            engine_type: getSelectValue('form-catalog-engine-type'),
            engine_volume_from: getSelectValue('form-catalog-engine-volume-from'),
            engine_volume_to: getSelectValue('form-catalog-engine-volume-to'),
            power_from: getSelectValue('form-catalog-power-from'),
            power_to: getSelectValue('form-catalog-power-to'),
            gearbox: getSelectValue('form-catalog-gearbox'),
            body_type: getSelectValue('form-catalog-body-type'),
            seats: getSelectValue('form-catalog-seats'),
            color: getSelectValue('form-catalog-color'),
            sort: getSelectValue('form-catalog-sort') || DEFAULT_FILTERS.sort,
            seller_type: $('input[name="form-catalog-seller-type"]:checked').val() || DEFAULT_FILTERS.seller_type
        };
        
        // Remove empty fields to reduce payload size - backend only processes non-empty filters
        Object.keys(nextFilters).forEach(key => {
            if (nextFilters[key] === '' || nextFilters[key] === null || nextFilters[key] === undefined) {
                delete nextFilters[key];
            }
        });

        // Ensure defaults exist even if DOM values are empty
        nextFilters.sort = nextFilters.sort || DEFAULT_FILTERS.sort;
        nextFilters.seller_type = nextFilters.seller_type || DEFAULT_FILTERS.seller_type;

        // Dedupe: if effective filters didn't change and results are already rendered, don't reload cars
        const nextFiltersKey = getEffectiveFiltersKey(nextFilters);
        const currentFiltersKey = getEffectiveFiltersKey(currentFilters);
        const hasRenderedResults =
            (carsContainer.find('.single-car').length > 0) ||
            ($('.no-results-wrapper:visible').length > 0);

        if (nextFiltersKey === currentFiltersKey && hasRenderedResults) {
            // Keep URL in sync (e.g. when make/model slugs resolve) without reloading results
            setTimeout(() => {
                updateCatalogURL();
            }, 100);
            return;
        }

        // Commit to loading
        isLoading = true;
        currentPage = 1; // Reset page counter for new filter results
        hasMore = true; // Reset hasMore flag for new filter results
        currentFilters = nextFilters;
        
        // Add textual values for make and model if available
        const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
        if (makeSelect && currentFilters.make_id) {
            const makeData = makeSelect.options && makeSelect.options[currentFilters.make_id];
            if (makeData) {
                currentFilters.make_name = makeData.text;
                currentFilters.make_slug = makeData.slug || '';
            }
        }
        
        const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
        if (modelSelect && currentFilters.model_id) {
            const modelData = modelSelect.options && modelSelect.options[currentFilters.model_id];
            if (modelData) {
                currentFilters.model_name = modelData.text;
                currentFilters.model_slug = modelData.slug || '';
            }
        }
        
        // Save to "recent searches" (debounced so we don't store intermediate typing states)
        scheduleSaveRecentSearch(currentFilters);
        
        
        // Show loading
        loadingIndicator.show();
        carsContainer.hide();
        noResultsMessage.hide();
        
        // Save filters to server and then load cars
        saveFiltersToServer(currentFilters, function() {
            // Load cars with filters after save completes
            loadCars();
        });

        // --- DYNAMIC URL UPDATE ---
        // Update URL after a short delay to ensure Selectize data is loaded
        setTimeout(() => {
            updateCatalogURL();
        }, 100);
        
        // Store all filters in localStorage instead of URL
        localStorage.setItem('catalog_filters', JSON.stringify(currentFilters));
        // --- END DYNAMIC URL UPDATE ---
    }

    function updateCarOrderRequestLink() {
        const link = $('.car-order-request-catalog-link');
        if (!link.length) {
            return;
        }

        const params = new URLSearchParams();
        params.set('source', link.data('source') || 'catalog_no_results');

        const filterMap = {
            make_id: 'make_id',
            model_id: 'model_id',
            make_name: 'make',
            model_name: 'model',
            year_from: 'year_from',
            year_to: 'year_to',
            price_from: 'price_from',
            price_to: 'price_to'
        };

        Object.keys(filterMap).forEach(function (key) {
            const value = currentFilters && currentFilters[key] ? String(currentFilters[key]).trim() : '';
            if (value !== '') {
                params.set(filterMap[key], value);
            }
        });

        try {
            params.set('filter_snapshot_json', JSON.stringify(currentFilters || {}));
        } catch (e) {}

        const baseUrl = link.data('base-url') || '/car-order-request';
        link.attr('href', baseUrl + '?' + params.toString());
    }

    function hasMeaningfulSearchFilter(filters) {
        if (!filters || typeof filters !== 'object') {
            return false;
        }
        const ignored = ['category', 'v_type', 'sort', 'seller_type', 'make_name', 'make_slug', 'model_name', 'model_slug'];
        return Object.keys(filters).some(function (key) {
            if (ignored.indexOf(key) !== -1) {
                return false;
            }
            const value = filters[key];
            return value !== null && value !== undefined && String(value).trim() !== '' && String(value).trim() !== 'all';
        });
    }

    function trackMetaCatalogSearch(response) {
        if (currentPage !== 1 || !hasMeaningfulSearchFilter(currentFilters)) {
            return;
        }

        const resultCount = Number((response && (response.total || response.totalCars || response.total_cars)) || 0);
        const searchKey = getEffectiveFiltersKey(currentFilters) + '|' + (Number.isFinite(resultCount) ? resultCount : 0);
        if (searchKey === lastTrackedMetaSearchKey) {
            return;
        }
        lastTrackedMetaSearchKey = searchKey;

        const searchParts = [
            currentFilters.make_name || currentFilters.make || '',
            currentFilters.model_name || currentFilters.model || ''
        ].filter(function (part) { return String(part || '').trim() !== ''; });

        const payload = {
            search_string: searchParts.length ? searchParts.join(' ') : (currentFilters.category || currentFilters.v_type || 'catalog'),
            content_category: currentFilters.category || currentFilters.v_type || 'catalog',
            result_count: Number.isFinite(resultCount) ? resultCount : 0,
            seller_type: currentFilters.seller_type || '',
            make: currentFilters.make_name || '',
            model: currentFilters.model_name || '',
            price_from: currentFilters.price_from || '',
            price_to: currentFilters.price_to || '',
            year_from: currentFilters.year_from || '',
            year_to: currentFilters.year_to || ''
        };

        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackCatalogSearch === 'function') {
            window.CarBuyAnalytics.trackCatalogSearch(payload);
            return;
        }
        if (!window.CarBuyMetaPixel || typeof window.CarBuyMetaPixel.track !== 'function') {
            return;
        }
        window.CarBuyMetaPixel.track('Search', payload);
        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.track === 'function') {
            window.CarBuyAnalytics.track('catalog_search', payload);
        }
    }

    // Recent search actions (catalog page)
    $(document).on('click', '.recent-searches--catalog .recent-search-chip-btn', function (e) {
        e.preventDefault();
        const key = $(this).attr('data-recent-key') || '';
        const api = window.CarBuyRecentSearches;
        if (!api || !key || typeof api.get !== 'function') return;
        const entry = api.get(key);
        if (!entry || !entry.filters) return;
        applyRecentSearchToCatalog(entry.filters);
    });

    $(document).on('click', '.recent-searches--catalog .recent-search-chip-remove', function (e) {
        e.preventDefault();
        const key = $(this).attr('data-recent-key') || '';
        const api = window.CarBuyRecentSearches;
        if (!api || !key || typeof api.remove !== 'function') return;
        api.remove(key);
        scheduleRenderRecentSearchesCatalog(0);
    });

    $(document).on('click', '.recent-searches--catalog .recent-searches-clear', function (e) {
        e.preventDefault();
        const api = window.CarBuyRecentSearches;
        if (!api || typeof api.clear !== 'function') return;
        api.clear();
        scheduleRenderRecentSearchesCatalog(0);
    });

    // LOAD CARS FUNCTION
    function loadCars() {
        // Safety check - ensure required elements exist
        if (!carsContainer.length || !loadingIndicator.length) {
            return;
        }
        
        let data = { filters: currentFilters, page: currentPage };
        
        if (carsRequest && carsRequest.readyState !== 4) {
            try { carsRequest.abort(); } catch (e) {}
        }
        
        // Use standardized csrfSafeAjaxPost for consistent CSRF handling
        if (typeof csrfSafeAjaxPost === 'function') {
            carsRequest = csrfSafeAjaxPost(
                '/ajax/catalog/filter-cars',
                data,
                function(response) {
                    isLoading = false;
                    if (loadingIndicator.length) loadingIndicator.hide();

                    if (response.success) {
                        trackMetaCatalogSearch(response);
                        if (response.cars && response.cars.length > 0) {
                            let html = renderCarsHtml(response.cars);
                            const beforeCount = carsContainer.children().length;
                            if (currentPage === 1) {
                                carsContainer.html(html);
                            } else {
                                carsContainer.append(html);
                            }
                            carsContainer.show();

                            // Sync favourite buttons for newly rendered cards
                            try {
                                if (window.CarBuyFavorites && typeof window.CarBuyFavorites.sync === 'function') {
                                    window.CarBuyFavorites.sync(carsContainer[0] || document);
                                }
                            } catch (e) {}

                            // Hide the no-results-wrapper when cars are loaded
                            $(".no-results-wrapper").addClass("d-none").hide();
                            if (noResultsMessage.length) noResultsMessage.hide();
                            hasMore = (response.hasMore === true || response.has_more === true);
                            if (typeof response.currentPage !== 'undefined') {
                                currentPage = parseInt(response.currentPage, 10) || currentPage;
                            }
                            try {
                                const $batch = (currentPage === 1)
                                    ? carsContainer.children().slice(0)
                                    : carsContainer.children().slice(beforeCount);
                                injectCatalogInlineAdPlaceholderForBatch(currentPage, $batch, response.inlineAd === true);
                            } catch (e) {}
                            
                            // Trigger car appear animation for new cars
                            if (typeof triggerCarAppearAnimation === 'function') {
                                triggerCarAppearAnimation();
                            }
                            
                            // Fallback: Remove animation class immediately if animation doesn't work
                            setTimeout(function() {
                                $('.single-car.before-animation-visibility-backface').removeClass('before-animation-visibility-backface');
                            }, 2000);
                            // Persist state for refresh restore
                            try {
                                sessionStorage.setItem('catalogCarsHtml', carsContainer.html());
                                sessionStorage.setItem('catalogPage', String(currentPage));
                                sessionStorage.setItem('catalogHasMore', String(hasMore));
                                sessionStorage.setItem('catalogFilters', JSON.stringify(currentFilters || {}));
                                sessionStorage.setItem('catalogScroll', String(window.scrollY || window.pageYOffset || 0));
                                touchCatalogSessionLang();
                            } catch (e) {}
                        } else {
                            // No cars: clear container and show no results
                            carsContainer.html('');
                            carsContainer.hide();
                            updateCarOrderRequestLink();
                            // Show the no-results-wrapper
                            $(".no-results-wrapper").removeClass("d-none").show();
                            hasMore = false;
                        }
                    } else {
                        // On error, also show no results message
                        carsContainer.html('');
                        carsContainer.hide();
                        updateCarOrderRequestLink();
                        $(".no-results-wrapper").removeClass("d-none").show();
                    }
                },
                function(xhr, status, error) {
                    isLoading = false;
                    if (loadingIndicator.length) loadingIndicator.hide();
                    if (xhr && xhr.status === 403) {
                        if (window.UniversalHelpers && window.UniversalHelpers.handleCsrfError) {
                            window.UniversalHelpers.handleCsrfError();
                        }
                    }
                }
            );
        } else {
            // Fallback: Inject CSRF token manually if csrfSafeAjaxPost is not available
            // CRITICAL: For cookie-based CSRF, we MUST use the cookie value (source of truth)
            let csrfName = 'carbuy_csrf';
            let csrfValue = '';
            
            // Method 1: Get from cookie (REQUIRED for cookie-based CSRF)
            if (window.CSRFHelper && window.CSRFHelper.getCSRFCookie) {
                csrfValue = window.CSRFHelper.getCSRFCookie();
                if (csrfValue && csrfValue.length >= 32) {
                    // Cookie found and valid
                } else {
                    csrfValue = '';
                }
            }
            
            // Method 2: Get from CSRF Helper (fallback to meta tags)
            if (!csrfValue && window.CSRFHelper && window.CSRFHelper.getCSRFData) {
                const csrfData = window.CSRFHelper.getCSRFData();
                if (csrfData && csrfData.name && csrfData.value && csrfData.value.length >= 32) {
                    csrfName = csrfData.name;
                    csrfValue = csrfData.value;
                }
            }
            
            // Method 3: Get from meta tag (last resort)
            if (!csrfValue) {
                const metaCsrf = document.querySelector('meta[name="csrf-token"]');
                if (metaCsrf) {
                    csrfValue = metaCsrf.getAttribute('content');
                }
            }
            
            // Method 4: Get from input field (final fallback)
            if (!csrfValue) {
                const csrfInput = document.querySelector('input[name="carbuy_csrf"]') || document.querySelector('input[name="csrf_test_name"]');
                if (csrfInput && csrfInput.value) {
                    csrfName = csrfInput.name;
                    csrfValue = csrfInput.value;
                }
            }
            
            // Remove any old CSRF tokens and inject cookie value
            if (csrfValue && csrfValue.length >= 32) {
                delete data.carbuy_csrf;
                delete data.csrf_test_name;
                delete data[csrfName];
                data[csrfName] = csrfValue;
            } else {
                console.error('CSRF token not found in cookie - request will fail');
            }
            
            carsRequest = $.ajax({
                url: '/ajax/catalog/filter-cars',
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function(response) {
                    isLoading = false;
                    if (loadingIndicator.length) loadingIndicator.hide();
                    
                    // Update CSRF token from response
                    if (window.CSRFHelper && window.CSRFHelper.updateCSRFMeta) {
                        window.CSRFHelper.updateCSRFMeta(response);
                    }
                    
                    if (response.success) {
                        trackMetaCatalogSearch(response);
                        if (response.cars && response.cars.length > 0) {
                            let html = renderCarsHtml(response.cars);
                            const beforeCount = carsContainer.children().length;
                            if (currentPage === 1) {
                                carsContainer.html(html);
                            } else {
                                carsContainer.append(html);
                            }
                            carsContainer.show();

                            // Sync favourite buttons for newly rendered cards
                            try {
                                if (window.CarBuyFavorites && typeof window.CarBuyFavorites.sync === 'function') {
                                    window.CarBuyFavorites.sync(carsContainer[0] || document);
                                }
                            } catch (e) {}

                            $(".no-results-wrapper").addClass("d-none").hide();
                            if (noResultsMessage.length) noResultsMessage.hide();
                            hasMore = (response.hasMore === true || response.has_more === true);
                            if (typeof response.currentPage !== 'undefined') {
                                currentPage = parseInt(response.currentPage, 10) || currentPage;
                            }
                            try {
                                const $batch = (currentPage === 1)
                                    ? carsContainer.children().slice(0)
                                    : carsContainer.children().slice(beforeCount);
                                injectCatalogInlineAdPlaceholderForBatch(currentPage, $batch, response.inlineAd === true);
                            } catch (e) {}
                            
                            if (typeof triggerCarAppearAnimation === 'function') {
                                triggerCarAppearAnimation();
                            }
                            
                            setTimeout(function() {
                                $('.single-car.before-animation-visibility-backface').removeClass('before-animation-visibility-backface');
                            }, 2000);
                            
                            try {
                                sessionStorage.setItem('catalogCarsHtml', carsContainer.html());
                                sessionStorage.setItem('catalogPage', String(currentPage));
                                sessionStorage.setItem('catalogHasMore', String(hasMore));
                                sessionStorage.setItem('catalogFilters', JSON.stringify(currentFilters || {}));
                                sessionStorage.setItem('catalogScroll', String(window.scrollY || window.pageYOffset || 0));
                                touchCatalogSessionLang();
                            } catch (e) {}
                        } else {
                            carsContainer.html('');
                            carsContainer.hide();
                            updateCarOrderRequestLink();
                            $(".no-results-wrapper").removeClass("d-none").show();
                            hasMore = false;
                        }
                    } else {
                        carsContainer.html('');
                        carsContainer.hide();
                        updateCarOrderRequestLink();
                        $(".no-results-wrapper").removeClass("d-none").show();
                    }
                },
                error: function(xhr, status, error) {
                    isLoading = false;
                    if (loadingIndicator.length) loadingIndicator.hide();
                    
                    // Update CSRF token from error response
                    if (window.CSRFHelper && xhr.responseJSON && window.CSRFHelper.updateCSRFMeta) {
                        window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                    }
                    
                    if (xhr && xhr.status === 403) {
                        if (window.UniversalHelpers && window.UniversalHelpers.handleCsrfError) {
                            window.UniversalHelpers.handleCsrfError();
                        }
                    }
                }
            });
        }
    }

    // LOAD MORE CARS FUNCTION
    function loadMoreCars() {
        if (isLoading || !hasMore) {
            return;
        }
        // Safety: do not load more if the list is empty (prevents "page 2 first")
        if (carsContainer.find('.single-car').length === 0) {
            return;
        }
        
        isLoading = true;
        currentPage++; // Increment page number for infinite scroll
        loadCars();
    }

    // Persist current state right before leaving the catalog (e.g. clicking a car)
    function persistCatalogState() {
        try {
            sessionStorage.setItem('catalogCarsHtml', carsContainer.html() || '');
            sessionStorage.setItem('catalogPage', String(currentPage || 1));
            sessionStorage.setItem('catalogHasMore', String(!!hasMore));
            sessionStorage.setItem('catalogFilters', JSON.stringify(currentFilters || {}));
            sessionStorage.setItem('catalogScroll', String(window.scrollY || window.pageYOffset || 0));
            touchCatalogSessionLang();
        } catch (e) {}
    }

    $(document).on('click', '#cars-wrapper a.single-car-link', function() {
        persistCatalogState();
    });

    // FORM SUBMISSION
    catalogParent.on("submit", function(e) {
        e.preventDefault();
        requestApplyFilters();
    });

    // Helper to get selected make and model slugs
    function getSelectedMakeSlug() {
        const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
        if (makeSelect && makeSelect.getValue()) {
            const selectedData = makeSelect.options && makeSelect.options[makeSelect.getValue()];
            const slug = selectedData && selectedData.slug ? selectedData.slug : '';
            
            return slug;
        }
        // Fallback to regular select
        const $opt = $('[name="form-catalog-brand"] option:selected');
        const slug = $opt.length ? $opt.data('slug') : '';
        
        return slug;
    }
    function getSelectedModelSlug() {
        const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
        if (modelSelect && modelSelect.getValue()) {
            const selectedData = modelSelect.options && modelSelect.options[modelSelect.getValue()];
            const slug = selectedData && selectedData.slug ? selectedData.slug : '';
            
            return slug;
        }
        // Fallback to regular select
        const $opt = $('[name="form-catalog-model"] option:selected');
        const slug = $opt.length ? $opt.data('slug') : '';
        
        return slug;
    }
    
    // Function to update catalog URL with current filters
    function updateCatalogURL() {
        let makeSlug = getSelectedMakeSlug();
        let modelSlug = getSelectedModelSlug();
        let path = '/catalog';
        
        // Vehicle categories only — never pushState /catalog/wheels/... from this page.
        let category = getActiveCategory();
        if (!isVehicleCatalogCategory(category)) {
            category = 'cars';
        }
        
        if (category) {
            path += '/' + encodeURIComponent(category);
            if (makeSlug && makeSlug !== 'undefined' && makeSlug !== '') {
                path += '/' + encodeURIComponent(makeSlug);
                if (modelSlug && modelSlug !== 'undefined' && modelSlug !== '') {
                    path += '/' + encodeURIComponent(modelSlug);
                }
            }
        }
        
        
        
        // Update URL with only category/make/model (no filter parameters)
        // Preserve hash (e.g. #open-filters) when normalizing legacy URLs.
        const hash = window.location.hash || '';
        let nextUrl = path + hash;
        if (focusedCarIds.length > 0) {
            nextUrl = path + '?ids=' + encodeURIComponent(focusedCarIds.join(',')) + hash;
        }
        if (window.location.pathname + window.location.search + hash !== nextUrl && window.location.pathname + hash !== nextUrl) {
            window.history.pushState({}, '', nextUrl);
        }
    }
    


    // On filter change, save to localStorage
    // $(document).on('change', '[name="form-catalog-brand"]', function(e, skipFilters) {
    //     // Clear model using Selectize API if available
    //     const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
    //     if (modelSelect) {
    //         modelSelect.clear(true);
    //     } else {
    //         $('[name="form-catalog-model"]').val('').trigger('change');
    //     }
    //     if (!skipFilters) applyFilters();
    // });
    // $(document).on('change', '[name="form-catalog-model"]', function(e, skipFilters) {
    //     if (!skipFilters) applyFilters();
    // });
    $(document).on("click", ".catalog-filters-non-dropdown-link", function(e) {
        const newCategory = $(this).data('category');
        // Wheels/Trailers are separate catalog pages. Cancel pending applyFilters/updateCatalogURL
        // so a delayed timer cannot pushState /catalog/wheels/audi/q7 and poison localStorage.
        if (isExternalCatalogCategory(newCategory)) {
            e.preventDefault();
            cancelPendingFilterWork();
            const href = $(this).attr('href') || (newCategory === 'trailers' ? '/catalog/trailers' : '/catalog/wheels');
            window.location.href = href;
            return;
        }

        e.preventDefault();
        $('.catalog-filters-non-dropdown-link').removeClass('active');
        $(this).addClass('active');
        if (newCategory) {
            // Clear ALL filters when switching categories (except category itself)
            // This prevents invalid filter combinations like "motorcycles with diesel engine and 5 seats"
            
            // Clear make and model using Selectize API
            const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
            const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
            
            if (makeSelect) {
                makeSelect.clear(true);
            } else {
                $('[name="form-catalog-brand"]').val('').trigger('change');
            }
            
            if (modelSelect) {
                modelSelect.clear(true);
            } else {
                $('[name="form-catalog-model"]').val('').trigger('change');
            }
            
            // Clear all other filter fields
            $('[name="form-catalog-price-from"]').val('');
            $('[name="form-catalog-price-to"]').val('');
            
            // Clear Selectize dropdowns
            const yearFromSelect = $('[name="form-catalog-year-from"]')[0]?.selectize;
            if (yearFromSelect) {
                yearFromSelect.clear(true);
            } else {
                $('[name="form-catalog-year-from"]').val('');
            }
            
            const yearToSelect = $('[name="form-catalog-year-to"]')[0]?.selectize;
            if (yearToSelect) {
                yearToSelect.clear(true);
            } else {
                $('[name="form-catalog-year-to"]').val('');
            }
            
            const engineTypeSelect = $('[name="form-catalog-engine-type"]')[0]?.selectize;
            if (engineTypeSelect) {
                engineTypeSelect.clear(true);
            } else {
                $('[name="form-catalog-engine-type"]').val('');
            }
            
            const engineVolumeFromSelect = $('[name="form-catalog-engine-volume-from"]')[0]?.selectize;
            if (engineVolumeFromSelect) {
                engineVolumeFromSelect.clear(true);
            } else {
                $('[name="form-catalog-engine-volume-from"]').val('');
            }
            
            const engineVolumeToSelect = $('[name="form-catalog-engine-volume-to"]')[0]?.selectize;
            if (engineVolumeToSelect) {
                engineVolumeToSelect.clear(true);
            } else {
                $('[name="form-catalog-engine-volume-to"]').val('');
            }
            
            const powerFromSelect = $('[name="form-catalog-power-from"]')[0]?.selectize;
            if (powerFromSelect) {
                powerFromSelect.clear(true);
            } else {
                $('[name="form-catalog-power-from"]').val('');
            }
            
            const powerToSelect = $('[name="form-catalog-power-to"]')[0]?.selectize;
            if (powerToSelect) {
                powerToSelect.clear(true);
            } else {
                $('[name="form-catalog-power-to"]').val('');
            }
            
            const gearboxSelect = $('[name="form-catalog-gearbox"]')[0]?.selectize;
            if (gearboxSelect) {
                gearboxSelect.clear(true);
            } else {
                $('[name="form-catalog-gearbox"]').val('');
            }
            
            const bodyTypeSelect = $('[name="form-catalog-body-type"]')[0]?.selectize;
            if (bodyTypeSelect) {
                bodyTypeSelect.clear(true);
            } else {
                $('[name="form-catalog-body-type"]').val('');
            }
            
            const seatsSelect = $('[name="form-catalog-seats"]')[0]?.selectize;
            if (seatsSelect) {
                seatsSelect.clear(true);
            } else {
                $('[name="form-catalog-seats"]').val('');
            }
            
            const colorSelect = $('[name="form-catalog-color"]')[0]?.selectize;
            if (colorSelect) {
                colorSelect.clear(true);
            } else {
                $('[name="form-catalog-color"]').val('');
            }
            
            // Reset sort to default
            const sortSelect = $('[name="form-catalog-sort"]')[0]?.selectize;
            if (sortSelect) {
                sortSelect.setValue('latest');
            } else {
                $('[name="form-catalog-sort"]').val('latest');
            }
            
            // Reset seller type to default
            $('input[name="form-catalog-seller-type"][value="' + DEFAULT_FILTERS.seller_type + '"]').prop('checked', true);
            
            // Fetch makes for the new category
            fetchMakesForCategory(newCategory);
            
            // Clear saved filters from localStorage to prevent restoring old filters
            try {
                localStorage.removeItem('catalog_filters');
            } catch (e) {}
            
            // Apply filters with cleared values
            setTimeout(() => {
                requestApplyFilters();
            }, 150);
        } else {
            requestApplyFilters();
        }
        
        // Apply category-specific filter visibility logic
        if (newCategory) {
            const $bodyTypeWrapper = $('.single-filter-wrapper[data-filter-type="body-type"]');
            const $seatsWrapper = $('.single-filter-wrapper[data-filter-type="seats"]');
            const $gearboxWrapper = $('.single-filter-wrapper[data-filter-type="gearbox"]');

            if (newCategory === 'trucks') {
                // Truck remove seats and body style
                $bodyTypeWrapper.hide();
                $seatsWrapper.hide();
                $gearboxWrapper.show();
            } else if (newCategory === 'motorcycles') {
                // Moto remove body style gearbox and seats
                $bodyTypeWrapper.hide();
                $seatsWrapper.hide();
                $gearboxWrapper.hide();
            } else if (newCategory === 'agriculture') {
                // Also agro should not have seats and body style
                $bodyTypeWrapper.hide();
                $seatsWrapper.hide();
                $gearboxWrapper.show();
            } else {
                // Default (cars) - show all
                $bodyTypeWrapper.show();
                $seatsWrapper.show();
                $gearboxWrapper.show();
            }
        }

        // Update URL after category change
        setTimeout(() => updateCatalogURL(), 100);
    });
    catalogParent.on("change", '[name="form-catalog-sort"]', function() { requestApplyFilters(); });
    // Seller type radio button change handler
    catalogParent.on("change", 'input[name="form-catalog-seller-type"]', function() { 
        requestApplyFilters(); 
    });

    // Beta: seller-type toggle buttons (outside filters) – sync with radios and apply
    $(document).on('click', '.catalog-page .seller-type-toggle-btn', function(e) {
        const btn = $(this);
        const sellerType = btn.attr('data-seller-type');
        if (!isValidCatalogSellerType(sellerType)) return;
        e.preventDefault();
        const $radios = catalogParent.find('input[name="form-catalog-seller-type"][value="' + sellerType + '"]');
        if ($radios.length) {
            $radios.prop('checked', true);
            $('.catalog-page .catalog-seller-type-toggle .seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
            btn.addClass('active').attr('aria-pressed', 'true');
            requestApplyFilters();
        }
    });
    
    // Seller-type change handled by form-level change handler above
    
    // Ensure all Selectize dropdowns trigger applyFilters on change
    $(document).on('change', 'select[name*="form-catalog-"]', function(e) {
        const name = $(this).attr('name');
        // Skip make/model/sort as they're handled by Selectize onChange
        if (name === 'form-catalog-brand' || name === 'form-catalog-model' || name === 'form-catalog-sort') return;
        requestApplyFilters();
    });

    // Helper: Fetch makes for a category and repopulate the makes dropdown
    function fetchMakesForCategory(category) {
        let data = { category: category };
        if (window.CSRFHelper && typeof window.CSRFHelper.refreshCSRFToken === 'function') {
            window.CSRFHelper.refreshCSRFToken().then(function(csrf) {
                data[csrf.csrf_name] = csrf.csrf_hash;
                if (makesRequest && makesRequest.readyState !== 4) {
                    try { makesRequest.abort(); } catch (e) {}
                }
                makesRequest = $.ajax({
                    url: '/ajax/get-makes',
                    type: 'POST',
                    data: data,
                    dataType: 'json',
                    success: function(response) {
                        if (window.CSRFHelper && typeof window.CSRFHelper.updateCSRFMeta === 'function') {
                            window.CSRFHelper.updateCSRFMeta(response);
                        }
                        if (response.success && response.makes) {
                            const $makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
                            if ($makeSelect) {
                                $makeSelect.clearOptions();
                                // Add default "All" option at the top (use translation if available)
                                const allText = (window.catalogTranslations && window.catalogTranslations.all) ? window.catalogTranslations.all : 'Visi';
                                const allMakesText = $('select[name="form-catalog-brand"]').find('option[value=""]').text() || allText;
                                // Collect makes and rebuild with "All" at top
                                const makesOptions = [];
                                response.makes.forEach(function(make) {
                                    const slug = make.slug || make.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                                    makesOptions.push({
                                        value: make.id,
                                        text: make.name,
                                        slug: slug
                                    });
                                });
                                $makeSelect.clearOptions();
                                $makeSelect.addOption([{ value: 'all', text: allMakesText, slug: '' }, ...makesOptions]);
                                $makeSelect.refreshOptions(false);
                                // Default to "all" (All makes)
                                $makeSelect.setValue('all', true);
                                $makeSelect.enable();
                                if (pendingFiltersFromStorage && pendingFiltersFromStorage.category === category && !pendingAppliedByCategory[category]) {
                                    try { tryApplyPendingMakeModel(pendingFiltersFromStorage); } catch (e) {}
                                }
                            }
                        }
                    },
                    error: function(xhr, status, error) {
                        if (xhr && xhr.responseJSON && window.CSRFHelper && typeof window.CSRFHelper.updateCSRFMeta === 'function') {
                            window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                        }
                    }
                });
            });
        }
    }

    // Apply saved make/model after makes (and later models) are available
    function tryApplyPendingMakeModel(filters) {
        const makeSelect = $('[name="form-catalog-brand"]')[0]?.selectize;
        if (!makeSelect) return;
        const category = getActiveCategory();
        if (!filters || !filters.category || filters.category !== category) return;

        let appliedMake = false;
        if (filters.make_id && makeSelect.options && makeSelect.options[filters.make_id]) {
            makeSelect.setValue(filters.make_id);
            appliedMake = true;
        } else if (filters.make) {
            const nameLower = String(filters.make).toLowerCase();
            for (const [id, option] of Object.entries(makeSelect.options || {})) {
                if (option.text && option.text.toLowerCase() === nameLower) {
                    makeSelect.setValue(id);
                    filters.make_id = id;
                    appliedMake = true;
                    break;
                }
            }
        }

        if (!appliedMake) return;

        const modelSelect = $('[name="form-catalog-model"]')[0]?.selectize;
        const useModelId = !!filters.model_id;
        const modelNameLower = filters.model ? String(filters.model).toLowerCase() : '';
        const makeIdToLoad = filters.make_id || makeSelect.getValue();
        if (makeIdToLoad && window.UniversalHelpers && typeof window.UniversalHelpers.loadModelsByMake === 'function') {
            const maybePromise = window.UniversalHelpers.loadModelsByMake(makeIdToLoad);
            const applyModel = () => {
                if (modelSelect) {
                    if (useModelId && modelSelect.options && modelSelect.options[filters.model_id]) {
                        modelSelect.setValue(filters.model_id);
                    } else if (modelNameLower) {
                        for (const [mid, mopt] of Object.entries(modelSelect.options || {})) {
                            if (mopt.text && mopt.text.toLowerCase() === modelNameLower) {
                                modelSelect.setValue(mid);
                                filters.model_id = mid;
                                break;
                            }
                        }
                    }
                }
            };
            if (maybePromise && typeof maybePromise.then === 'function') {
                maybePromise.then(applyModel);
            } else {
                // Fallback small delay to allow model options to populate
                setTimeout(applyModel, 300);
            }
        }
        pendingAppliedByCategory[category] = true;
    }

    // SORT CHANGE - Handled by Selectize onChange event
    // catalogParent.on("change", '[name="form-catalog-sort"]', function() {
    //     applyFilters();
    // });

    // FILTERS DROPDOWN TOGGLE WITH SLIDE AND opened-filters CLASS
    $(document).on("click", ".catalog-filters-dropdown .catalog-filters-dropdown-link", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $catalogPage = $(this).closest('.catalog-page');
        var $filtersSection = $catalogPage.find('.filters-section');
        var $closeHidden = $(this).find('.close-hidden');

        // Slide toggle the filters section
        $filtersSection.stop(true, true).slideToggle(300, () => {
            const isVisible = $filtersSection.is(':visible');
            $filtersSection.toggleClass("filters-open", isVisible);
            $(this).toggleClass("opened-filters", isVisible);
            $(this).toggleClass("active", isVisible);
            $closeHidden.toggleClass("d-block", isVisible);
            setFiltersOpenCookie(isVisible);
        });
    });

    // Clear filters button handler
    $(document).on('click', '.clean-filters', function(e) {
        e.preventDefault();
        
        // Only reset all fields except for vehicle type (category)
        var $form = $('.catalog-form');
        if ($form.length && $form[0]) {
            // Store current category
            var $activeCategory = $('.catalog-filters-non-dropdown-link.active');
            var category = $activeCategory.data('category');
            // Reset all fields - set dropdowns to "All" (empty value) and clear inputs
            $form.find('input, select').each(function() {
                var name = $(this).attr('name');
                if (name === 'form-catalog-category' || name === 'form-catalog-type' || $(this).hasClass('catalog-filters-non-dropdown-link')) {
                    // Skip vehicle type/category
                    return;
                }
                if ($(this).is('select')) {
                    if (this.selectize) {
                        // Set value to "all" for dropdowns that have "All" option, empty for from/to dropdowns
                        const $select = $(this);
                        const hasAllOption = $select.find('option[value="all"]').length > 0;
                        const valueToSet = hasAllOption ? 'all' : '';
                        this.selectize.setValue(valueToSet, true);
                        this.selectize.enable();
                    } else {
                        // For non-selectize selects, set to "all" if option exists, otherwise empty
                        const $select = $(this);
                        const hasAllOption = $select.find('option[value="all"]').length > 0;
                        $(this).val(hasAllOption ? 'all' : '');
                    }
                } else if ($(this).is(':radio') || $(this).is(':checkbox')) {
                    $(this).prop('checked', false);
                } else {
                    // Clear input fields (price from/to, etc.)
                    $(this).val('');
                }
            });
            // Set default sort using Selectize API if available
            const sortSelect = $form.find('[name="form-catalog-sort"]')[0]?.selectize;
            if (sortSelect) {
                sortSelect.setValue('latest', true);
            } else {
                $form.find('[name="form-catalog-sort"]').val('latest');
            }
            
            // Ensure seller type resets to the catalog default (carbuy)
            const sellerDefault = $form.find('input[name="form-catalog-seller-type"][value="' + DEFAULT_FILTERS.seller_type + '"]');
            if (sellerDefault.length) {
                sellerDefault.prop('checked', true);
            }
            // Sync Visi auto / Carbuy auto toggle buttons to match
            const $toggleWrap = $('.catalog-page .catalog-seller-type-toggle');
            if ($toggleWrap.length) {
                $toggleWrap.find('.seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
                $toggleWrap.find('.seller-type-toggle-btn[data-seller-type="' + DEFAULT_FILTERS.seller_type + '"]').addClass('active').attr('aria-pressed', 'true');
            }
            
            // Ensure all Selectize dropdowns are enabled (already done in the loop above, but double-check)
            const selectizeSelectors = [
                '[name="form-catalog-brand"]',
                '[name="form-catalog-model"]',
                '[name="form-catalog-year-from"]',
                '[name="form-catalog-year-to"]',
                '[name="form-catalog-engine-type"]',
                '[name="form-catalog-engine-volume-from"]',
                '[name="form-catalog-engine-volume-to"]',
                '[name="form-catalog-power-from"]',
                '[name="form-catalog-power-to"]',
                '[name="form-catalog-gearbox"]',
                '[name="form-catalog-body-type"]',
                '[name="form-catalog-seats"]',
                '[name="form-catalog-color"]',
                '[name="form-catalog-sort"]'
            ];
            
            selectizeSelectors.forEach(function(selector) {
                const selectElement = $form.find(selector)[0];
                if (selectElement && selectElement.selectize) {
                    // Ensure enabled and value is set to "all" for dropdowns with "All" option, empty for from/to
                    selectElement.selectize.enable();
                    if (selector !== '[name="form-catalog-sort"]') {
                        // Don't reset sort, it's already set to 'latest' above
                        const $select = $(selectElement);
                        const hasAllOption = $select.find('option[value="all"]').length > 0;
                        const valueToSet = hasAllOption ? 'all' : '';
                        selectElement.selectize.setValue(valueToSet, true);
                    }
                }
            });
            
            // Restore the active category tab
            if (category) {
                $('.catalog-filters-non-dropdown-link').removeClass('active');
                $('.catalog-filters-non-dropdown-link[data-category="' + category + '"]').addClass('active');
            }

            // Reload makes for the selected/active category so the brand list is repopulated
            if (category) {
                fetchMakesForCategory(category);
            } else {
                const pathParts = window.location.pathname.split('/');
                if (pathParts.length > 2 && pathParts[1] === 'catalog') {
                    const pathCategory = (pathParts[2] === 'newest') ? 'cars' : pathParts[2];
                    fetchMakesForCategory(pathCategory);
                }
            }
        }
        
        // Clear localStorage and refresh cars
        localStorage.removeItem('catalog_filters');
        requestApplyFilters();
    });

    // Ensure all filter fields trigger applyFilters on change
    $(document).on('change', '.catalog-form input, .catalog-form select', function(e) {
        // Avoid double trigger for make/model and sort (already handled by Selectize)
        if ($(this).attr('name') === 'form-catalog-brand' || 
            $(this).attr('name') === 'form-catalog-model' || 
            $(this).attr('name') === 'form-catalog-sort') return;
        requestApplyFilters();
    });
    
    // Add input event handlers for real-time updates on text/number inputs
    $(document).on('input', '.catalog-form input[type="text"], .catalog-form input[type="number"]', function(e) {
        // Debounce the input to avoid too many API calls
        clearTimeout($(this).data('inputTimer'));
        $(this).data('inputTimer', setTimeout(() => {
            requestApplyFilters();
        }, 500)); // Wait 500ms after user stops typing
    });

    // Helper: Format price for display (whole euros only)
    function formatPrice(value) {
        return formatPriceInt(value);
    }
    // Helper: Format price as integer (listing + leasing/monthly)
    function formatPriceInt(value) {
        return Math.round(Number(value) || 0).toLocaleString('lv-LV', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    // Initial render for "recent searches" pills
    scheduleRenderRecentSearchesCatalog(0);
});